<template>
  <div class="page-wrapper" style="overflow-y: auto;">
    <div class="container">
      <div class="row nav-container">
        <ul>
          <li><a class="active" href="#/admin/home/">메인</a></li>
          <li><a href="#/admin/checkin/">체크인</a></li>
          <li><a href="#/admin/settings/">세팅</a></li>
          <li><a href="#/admin/customers/">업체</a></li>
          <li><a href="#/admin/forwarders/">파트너</a></li>
          <li><a href="#/admin/users/">사용자</a></li>
          <li>
            <div class="logout" v-on:click="logout">로그아웃 v{{version}}</div>
          </li>
        </ul>
      </div>
    </div>


    <div class="container menu-list-container">
      <div class="row">
        <div class="col-3">
          <div class="container">
            <div class="row form-row">
              <div class="col-6">
                <label class="form-control">운송업체:</label>
              </div>
              <div class="col-6">
                <select class="form-control" v-model="filter.forwarder">
                  <option value="0">All</option>
                  <option v-for="(forwarder, index) in forwarders" :value="forwarder.id">{{forwarder.title}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="container-fluid">
            <div class="row form-row">
              <div class="col-3">
                <label class="form-control text-right">From:</label>
              </div>
              <div class="col-9">

                <input class="form-control" type="date" v-model="filter.date_from"/>
              </div>
              <div class="col-3">
                <label class="form-control text-right">To:</label>
              </div>
              <div class="col-9">
                <input class="form-control" type="date" v-model="filter.date_to"/>
              </div>
            </div>
            <div class="row form-row" v-if="pageState == -1">
              <div class="col-3">
                <label class="form-control text-right">업체:</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="filter.customer_id">
                  <option value="0">All</option>
                  <option v-for="(customer, index) in customers" :value="customer.id">{{customer.code}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3" v-if="pageState >= 0">
          <div class="container-fluid">
            <div class="row form-row">
              <div class="col-3">
                <label class="form-control">상태:</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="filter.state">
                  <option v-for="(item, index) in states" :value="item.state">{{item.title}}</option>
                </select>
              </div>
            </div>
            <div class="row form-row">
              <div class="col-3">
                <label class="form-control">업체:</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="filter.customer_id">
                  <option value="0">All</option>
                  <option v-for="(customer, index) in customers" :value="customer.id">{{customer.code}}</option>
                </select>
              </div>
            </div>

          </div>
        </div>
        <div class="col-3" v-if="pageState == -1">
          <div class="container-fluid">

            <div class="row form-row">
              <div class="col-3">
                <label class="form-control text-right">송장:</label>
              </div>
              <div class="col-9">
                <input class="form-control" v-model="filter.awb"/>

              </div>
            </div>
            <div class="row form-row">
              <div class="col-3">
                <label class="form-control text-right">발송인:</label>
              </div>
              <div class="col-9">
                <input class="form-control" v-model="filter.sender"/>

              </div>
            </div>
            <div class="row form-row">
              <div class="col-3">
                <label class="form-control text-right">수취인:</label>
              </div>
              <div class="col-9">
                <input class="form-control" v-model="filter.receiver"/>

              </div>
            </div>

          </div>
        </div>
        <div class="col-3">
          <div class="btn btn-primary" v-on:click="onGetPressed()" v-if="pageState > -1">불러오기</div>
          <div class="btn btn-primary" v-on:click="onSearchPressed()" v-if="pageState == -1">검색하기</div>
        </div>

      </div>

    </div>
    <div class="container">
      <div class="row border main-nav" style="position: relative;">

        <div class="state-button-bg" v-bind:class="'state-' + pageState">

        </div>
        <div class="col-2 state-button" v-bind:class="{'state-selected' : pageState == 0}" v-on:click="changeStage(0)">
          송장
        </div>
        <div class="col-2 state-button" v-bind:class="{'state-selected' : pageState == 1}" v-on:click="changeStage(1)">
          1차 마감
        </div>
        <div class="col-2 state-button" v-bind:class="{'state-selected' : pageState == 2}" v-on:click="changeStage(2)">
          2차 마감
        </div>
        <div class="col-2 state-button" v-bind:class="{'state-selected' : pageState == 3}" v-on:click="changeStage(3)">
          3차 마감
        </div>
        <div class="col-2 state-button" v-bind:class="{'state-selected' : pageState == 4}" v-on:click="changeStage(4)">
          Manifests
        </div>
        <div class="col-2 state-button" v-bind:class="{'state-selected' : pageState == -1}"
             v-on:click="changeStage(-1)">
          목록검색
        </div>
      </div>
    </div>
    <div class="container" style="position: sticky; top:0; background:#F2F2F2;box-shadow: 0 4px 2px -2px gray; margin-bottom: 10px; z-index:2;">
      <div class="row menu-list-container" style="min-height:100px;">
        <div class="col-6 text-left">
          <div v-if="pageState >= -1 && pageState < 4">
            <div v-show="pageState != 4" class="image-btn-container" v-on:click="openNewItemForm()" v-if="pageState == 0">
              <div class="image-btn"
                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_add_doc.png') + ')'}"/>
              송장등록
            </div>
            <div class="image-btn-container" v-on:click="downloadForm()" v-if="pageState == 0">
              <div class="image-btn"
                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_down_template.png') + ')'}"/>
              양식받기
            </div>

            <div class="image-btn-container" v-on:click="downloadForSlx()" style="display:none;">
              <div class="image-btn"
                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_download.png') + ')'}"/>
              SLX
            </div>

            <div class="image-btn-container" v-on:click="downloadForBridgeLogis()"  >
              <div class="image-btn"
                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_download.png') + ')'}"/>
              <span style="color: red; font-weight: bold;">Bridge Logis</span>(세로)
            </div>
<!--            <div class="image-btn-container" v-on:click="downloadForAllta()"  >-->
<!--              <div class="image-btn"-->
<!--                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_download.png') + ')'}"/>-->
<!--              <span style="color: red; font-weight: bold;">ALLTA Korea</span>(세로)-->
<!--            </div>-->

<!--            <div class="image-btn-container" v-on:click="downloadForDWH()">-->
<!--              <div class="image-btn"-->
<!--                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_download.png') + ')'}"/>-->
<!--              대운(가로)-->
<!--            </div>-->


            <div class="image-btn-container" v-on:click="printSelectedLabels()">
              <div class="image-btn"
                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_print.png') + ')'}"/>
              송장 출력
            </div>
            <div class="image-btn-container" v-on:click="printItems()" v-if="items.length > 0">
              <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic-label-3x1.png') + ')'}"/>
              송장출력(USB 라벨프린터)
            </div>
            <div class="image-btn-container" v-on:click="printItems(1)" v-if="items.length > 0">
              <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic-label-3x1.png') + ')'}"/>
              송장출력(USB 라벨프린터 가로)
            </div>
            <div class="image-btn-container" v-on:click="printItems(2)" v-if="items.length > 0">
              <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic-label-3x1.png') + ')'}"/>
              송장출력(A4 가로3)
            </div>
            <div class="image-btn-container" v-on:click="printItems(3)" v-if="items.length > 0">
              <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic-label-2x2.png') + ')'}"/>
              송장출력 (A4 2x2)
            </div>
            <div class="image-btn-container" v-on:click="toggleEditMode" v-bind:class="{'edit-mode-enabled': editMode == true}">
              EDIT
            </div>
            <div class="image-btn-container" @click="onfileselectorClick" style="background: #8BE6FF;"  v-if="pageState == 0">
              <input type="file" ref="file" style="display: none" v-on:change="addFilePickedUp">
              <div class="image-btn"
                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_upload.svg') + ')'}" />
              엑셀업로드
            </div>
            <div class="image-btn-container" v-on:click="downloadReport()" v-if="pageState == -1" style="background: #FFD4AD;">
              <div class="image-btn"
                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_download.png') + ')'}"/>
              엑셀다운
            </div>
            <div class="image-btn-container" v-on:click="getFTADocsForSelected" v-if="selectedItems.length > 0">
              FTA
            </div>
            <div class="image-btn-container" style="background:#8DCDA6 " v-on:click="printFTASelected" v-if="selectedItems.length > 0">

              <div class="image-btn"
                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_print.png') + ')'}"/>
              FTA 출력
            </div>
          </div>
          <div class="drop-zone" style="display: none;"v-cloak @drop.prevent="addFile" @dragover.prevent @dragenter="dragEnter"
               @dragleave="dragLeave" @dragend="dragEnd" v-bind:class="{'drop-enabled': dropEnabled == true}">
            엑셀파일 드롭

          </div>
        </div>
        <div class="col-3">

          <button v-show="pageState == 0" type="button" class="btn btn-primary" v-on:click="chageState(1)">1차마감하기
          </button>
          <button v-show="pageState == 1" type="button" class="btn btn-primary" v-on:click="chageState(2)">2차마감하기
          </button>
          <button v-show="pageState == 4" type="button" class="btn btn-primary" v-on:click="createManifest(2)">Manifest
            만들기
          </button>

          <button v-show="pageState == 2" type="button" class="btn btn-primary" v-on:click="chageState(3)">3차마감하기
          </button>
          <button v-show="pageState == 3" type="button" class="btn btn-primary" v-on:click="prepareToMoveOut">최종마감하기
          </button>
        </div>
        <div class="col-3">
          <table class="table" v-if="items!=false" style="background:white;">
            <tr>
              <td>총개수</td>
              <td>{{items.length}}</td>
            </tr>
            <tr>
              <td>총중량</td>
              <td>{{getTotalAW()}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="container" v-if="pageState == 4">
      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr>
              <th>Date</th>
              <th>AWB</th>
              <th>To</th>
              <th>ORG</th>
              <th>DEST</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in manifests">
              <td>{{item.cargo_date}}</td>
              <td>{{item.awb}}</td>
              <td>{{item.receiver}}</td>
              <td>{{item.origin}}</td>
              <td>{{item.destination}}</td>
              <td>
                <button class="btn btn-primary" v-on:click="onManifestEditClicked(index)">EDIT</button>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-12">
          <div class="container" v-if="currentManifest != false">
            <div class="row">
              <h5 class="text-right">
                <button class="btn btn-secondary" v-on:click="closeCurrentManifest()">닫기</button>
              </h5>
            </div>
            <div class="row">
              <div class="col-4 text-left">
                <h5>To</h5>
                {{currentManifest.receiver}}<br>
                {{currentManifest.address_3}}<br>
                {{currentManifest.address_2}}<br>
                {{currentManifest.address_1}} {{currentManifest.post_code}}<br>
                TEL:{{currentManifest.telephone}} FAX:{{currentManifest.fax}}
              </div>
              <div class="col-4">
                AIRLINE:{{currentManifest.airline}}<br>
                DATE:{{currentManifest.cargo_date}}<br>
                AWB:{{currentManifest.awb}}<br>
                ORIGIN:{{currentManifest.origin}}
              </div>
              <div class="col-4">
                FLIGHT:{{currentManifest.flight}}<br>
                FLIGHT2:{{currentManifest.flight2}}<br>
                DESTINATION:{{currentManifest.destination}}
              </div>
            </div>
            <div class="row">
              <h5>HOUSE</h5>
              <table class="table">
                <tr>
                  <th>#</th>
                  <th>NOP</th>
                  <th>Desc</th>
                  <th>Weight</th>
                  <th>Shipper</th>
                  <th>Consignee</th>
                  <th></th>
                </tr>
                <tr v-for="(item, index) in currentManifest.list">
                  <td>{{item.ref}}</td>
                  <td>{{item.nop}}</td>
                  <td>{{item.description}}</td>
                  <td>{{(item.weight/100).toFixed(1)}}</td>
                  <td class="text-left">{{item.shipper_title}}<br>{{item.shipper_address_1}}<br>{{item.shipper_address_2}}<br>{{item.shipper_post_code}}
                  </td>
                  <td class="text-left">
                    {{item.consignee_title}}<br>
                    {{item.consignee_address_1}}<br>
                    {{item.consignee_address_2}}<br>
                    {{item.consignee_address_3}},{{item.consignee_post_code}},SOUTH KOREA
                  </td>
                  <td>
                    <button type="button" class="btn btn-primary" v-on:click="editHouse(index)">수정</button>
                    <button type="button" class="btn btn-success"
                            v-on:click="assignItemsToHouse(item.manifest_id, item.id, item.ref)">송장지정
                    </button>
                  </td>
                </tr>
              </table>
            </div>
            <div class="row">
              <div class="col-6">
                <button class="btn btn-primary" v-on:click="createNewHouseForm()">HOUSE 추가하기</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="container" v-if="pageState < 4" style="padding-bottom:100px;">
      <table class="table">
        <tr class="sticky-header">
          <th v-on:click="selectAll()">선택</th>
          <th>#</th>
          <th style="cursor:pointer" v-on:click="sortByDispatchDate">발송일 <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th>Printed</th>
          <th style="cursor:pointer" v-on:click="sortByCode">업체 <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th style="cursor:pointer" v-on:click="sortBySender">발신인 <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th style="cursor:pointer" v-on:click="sortByAWB">송장 <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th style="cursor:pointer" v-on:click="sortByReceiver">수신인 <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th>Description</th>
          <th style="cursor:pointer" v-on:click="sortByValue">Value <i class="fa fa-sort" style="float:right;font-size: 22px;"></i></th>
          <th style="display:none;">F</th>
          <th>CT</th>
          <th v-if="editMode == false">GW / CW</th>
          <th v-if="editMode == true">GW</th>
          <th v-if="editMode == true">CW</th>
          <th>가격</th>
          <th></th>

          <th v-if="pageState == -1">상태</th>
        </tr>
        <tbody>
          <tr v-for="(item, index) in items" class="hovorable-item" v-bind:class="{'item-empty': getItemColor(item) == 0, 'item-not-measured': getItemColor(item) == 1, 'item-in-custom': item.state == 6}" :key="item.id + '-item'">
            <td><input type="checkbox" v-bind:value="index" v-model="selectedItems" @click="updateCheckall($event, index)"/></td>
            <td>{{index+1}}</td>
            <td v-if="editMode == true"><input type="date" class="form-control" v-model="item.dispatch_date" @change="updateDispatchDate(index)"/></td>
            <td v-if="editMode == false">{{item.dispatch_date}}</td>
            <td>{{item.printedCount}}</td>
            <td>{{item.code}}</td>
            <td>{{item.sender}}</td>
            <td><span class="clickable-item" v-on:click="editItemForm(index)" style="cursor: pointer">{{item.awb}}</span></td>
            <td>{{item.receiver}}</td>
            <td class="text-left">{{getDescriptionList(item.list)}}</td>
            <td>${{(parseFloat(item.value)).toFixed(2)}}</td>
            <td style="display:none;">{{item.forwarder_string}}</td>
            <td>{{item.ct}}</td>
            <td v-if="editMode == false">{{(item.measured_weight/100).toFixed(2)}} / {{(item.volume_weight/100).toFixed(2)}}</td>
            <td v-if="editMode == true && item.new_measured_weight != undefined"><input type="number" class="form-control" v-model="item.new_measured_weight" @change="weightChanged(index)"/></td>
            <td v-if="editMode == true && item.new_volume_weight != undefined"><input type="number" class="form-control" v-model="item.new_volume_weight" @change="weightChanged(index)"/></td>
            <td>£{{(item.price/100).toFixed(2)}}</td>
            <td>
              <div class="image-btn" style="display:none;"
                   :style="{backgroundImage: 'url(' + require('@/assets/images/ic_edit.png') + ')'}"
                   v-on:click="editItemForm(index)"/>
              <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic_delete.png') + ')'}"
                   v-on:click="deleteItem(index)"/>
              <div class="image-btn" :style="{backgroundImage: 'url(' + require('@/assets/images/ic_print.png') + ')'}"
                   v-on:click="printItem(index)"/>
              <span><i class="fa fa-file" v-on:click="getFTADoc(item.id)"> FTA</i></span>
            </td>
            <td class="tooltip-parent" v-if="pageState == -1" :key="item.id + '-state'" v-html="getStateTimeString(index)" v-on:click="openStatusPage(item.awb)"></td>
          </tr>
        </tbody>
      </table>

    </div>
    <div class="new-item-form" v-if="newManiItem != false">
      <div class="scroll-container">
        <div class="container">
          <div class="row section-container">
            <div class="col-8 text-left">
              <h2>Manifest</h2>
            </div>
            <div class="col-4 text-right">
              <img src="@/assets/images/ic_print.svg" width="40px;" v-on:click="printManifest()"/>
            </div>
          </div>
          <div class="row section-container">
            <div class="col-4">
              <div class="container">
                <div class="form-group row">
                  <div class="col-6"><label>AWB:</label></div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="newManiItem.awb" placeholder="AWB"
                           @change="onAWBEntered()"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6">DATE:</div>
                  <div class="col-6">
                    <input type="date" class="form-control" v-model="newManiItem.cargo_date"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6">CARGO TYPe:</div>
                  <div class="col-6">
                    <select class="form-control" v-model="newManiItem.cargo_type">
                      <option value="UNKNOWN CARGO">UNKNOWN CARGO</option>
                      <option value="KNOWN CARGO">KNOWN CARGO</option>
                    </select>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-4">
              <div class="container">
                <div class="form-group row">
                  <div class="col-6"><label>FLIGHT:</label></div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="newManiItem.flight" placeholder="FLIGHT"/>
                  </div>
                  <div class="col-6"><label>FLIGHT2:</label></div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="newManiItem.flight2" placeholder="FLIGHT2"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6"><label>ORIGIN:</label></div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="newManiItem.origin" placeholder="ORIGIN"/>
                  </div>
                  <div class="col-6"><label>DESTINATION:</label></div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="newManiItem.destination" placeholder="DEST"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6"><label>Departure Time</label></div>
                  <div class="col-6"><input type="datetime-local" v-model="newManiItem.departure_time"/></div>
                </div>
                <div class="form-group row">
                  <div class="col-6"><label>Arrival Time</label></div>
                  <div class="col-6"><input type="datetime-local" v-model="newManiItem.arrival_time"/></div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="container">
                <div class="form-group row">
                  <div class="col-4">
                    Receiver:
                  </div>
                  <div class="col-8">
                    <select v-model="newManiItem.receiver_id" @change="onManiReceiverSelected">
                      <option :value="0">Select</option>
                      <option v-for="(item, index) in forwarders" :value="item.id">{{item.title}}</option>
                    </select>
                  </div>

                </div>
                <div class="form-group row">
                  <div class="col-4">업체명</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newManiItem.receiver"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">우편번호</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newManiItem.post_code"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">주소</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newManiItem.address_1"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4"></div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newManiItem.address_2"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4"></div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newManiItem.address_3"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">전화번호</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newManiItem.telephone"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4">FAX</div>
                  <div class="col-8">
                    <input type="text" class="form-control" v-model="newManiItem.fax"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">

            <h5>HOUSE
              <button class="btn btn-primary" v-on:click="addNewHouseItem(true)"> + 추가하기</button>
            </h5>
            <table class="table">
              <tr>
                <th>#</th>
                <th>House</th>
                <th>NOP</th>
                <th>Desc</th>
                <th>Weight</th>
                <th>Shipper</th>
                <th>Consignee</th>
                <th>Note</th>
                <th></th>
              </tr>
              <tr v-for="(item, index) in newManiItem.list">
                <td>{{item.ref}}</td>
                <td>
                  <input type="text" class="form-control" v-model="item.house_ref"/>
                </td>
                <td>
                  <input type="number" class="form-control" v-model="item.nop"/>
                </td>
                <td>
                  <input type="text" class="form-control" v-model="item.description"/>
                </td>
                <td>
                  <input type="text" class="form-control" v-model="item.weight"/>
                </td>
                <td>
                  <select class="form-control" v-model="item.shipper_id" @change="houseShipperChanged(index)">
                    <option value="0">직접입력</option>
                    <option v-for="(customer, index) in customers" :value="customer.id">[{{customer.code}}] {{customer.title}}</option>

                  </select>
                  <input type="text" class="form-control" v-model="item.shipper_title"/>
                  <input type="text" class="form-control" v-model="item.shipper_address_1"/>
                  <input type="text" class="form-control" v-model="item.shipper_address_2"/>
                  <input type="text" class="form-control" v-model="item.shipper_post_code"/>
                </td>
                <td>
                  <select class="form-control" v-model="item.consignee_id" @change="houseConsigneeChanged(index)">
                    <option value="0">직접입력</option>
                    <option v-for="(forwarder, index) in forwarders" :value="forwarder.id">{{forwarder.title}}</option>

                  </select>
                  <input type="text" class="form-control" v-model="item.consignee_title"/>
                  <input type="text" class="form-control" v-model="item.consignee_address_1"/>
                  <input type="text" class="form-control" v-model="item.consignee_address_2"/>
                  <input type="text" class="form-control" v-model="item.consignee_post_code"/>
                </td>

                <td>
                  <textarea class="form-control" rows="3" v-model="item.memo"/>
                </td>
                <td>
                  <button type="button" class="btn btn-danger" v-on:click="deleteHouse(index)">삭제</button>
                  <button class="btn btn-success" style="margin-top:10px;" v-on:click="printHouseBill(index)">House Bill</button>
                  <br/>
                  <br/>
<!--                  <img src="@/assets/images/ic_print.svg" v-on:click="printHouse(index)" width="40px;"/>-->
                  <div style="width: 140px; display:flex;">
                    <input type="number" :id="'house-print-count-' + index" value="1" style="width: 90px;"/>
                    <img src="@/assets/images/ic_print.svg"  style="margin-left:10px;"v-on:click="printHouse(index)" width="40px;"/>

                  </div>

<!--                  <span v-on:click="printHouse(index)"><i class="fas fa-print"></i></span>-->
                </td>
              </tr>
            </table>
          </div>
          <div class="row fixed-bottom menu-container">
            <div class="col-6">
              <div class="form-control btn btn-secondary" v-on:click="closeNewManiItemForm()">Close</div>
            </div>
            <div class="col-6">
              <div
                v-if="newManiItem.awb.length > 0 && newManiItem.cargo_date.length > 0 && newManiItem.cargo_date != '0000-00-00'"
                class="form-control btn btn-primary" v-on:click="submitNewMainfest()"><span v-if="newManiItem.id == 0">CREATE</span><span
                v-if="newManiItem.id > 0">UPDATE</span></div>

            </div>
          </div>
        </div>
        <div class="container text-left house-bill" style="padding-bottom: 100px;">
          <div class="row">
            <div class="col-12">
              HOUSE AIRWAY BILL
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              {{newManiItem.awb}}
            </div>
            <div class="col-6">
              {{newManiItem.awb}}
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              Shipper's Name and Address
              <br>
              UTASCO LTD
              <br>
              UNIT 11, FELTHAMBROOK INDUSTRIAL ESTATE
              FELTHAMBROOK WAY, FELTHAN
              <br>
              MIDDLESEX, TW13 7DU, UK
              <br>
              T. +44-20-8569-2588
              <br>
              EMAIL: INFO@UTASCO.CO.UK
              <br>
              UTASCO LTD

            </div>
            <div class="col-6">
              HOUSE AIR WAYBILL
              <br>
              issued by<br>
              <input v-model="newManiItem.airlineTitle" class="form-control"/>
              <input v-model="newManiItem.airlineAddress1" class="form-control"/>
              <input v-model="newManiItem.airlineAddress2" class="form-control"/>
<!--              KOREAN AIRLINES<br>-->
<!--              SEOSOMUN-RO 117<br>-->
<!--              JUNG-GU, SEOUL, KOREA-->
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              Consignee Name and Address<br>
              {{newManiItem.receiver}}<br>
              {{newManiItem.post_code}}<br>
              {{newManiItem.address_1}}<br>
              {{newManiItem.address_2}}<br>
              {{newManiItem.address_3}}<br>
              {{newManiItem.telephone}}<br>
              {{newManiItem.fax}}<br>
            </div>
            <div class="col-6">
              Accounting Information
              <br>
              <textarea type="text" v-model="newManiItem.accountingInfo" rows="5" style="width:100%;"/>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              Issuing Carrier's Agent Name and City
              <br>
              UTASCO LTD.<br>
              MIDDLESEX, TW13 7DU, UK

            </div>
            <div class="col-6">

            </div>
            <div class="col-3">
              Agent IATA code
              <br>
              91-4 5393/0002
            </div>
            <div class="col-3">
              Account No
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              Airport of Department (Addr of First Carrier) and Requested Routing<br>
              LONDON HEATHROW
            </div>
          </div>

          <div class="row">
            <div class="col-2">
              to<br>
              INCHEON
            </div>
            <div class="col-4">
              by first Carrier
              <br>
              {{newManiItem.flight}}
            </div>
            <div class="col-2">
              Currency<br>GBP
            </div>
            <div class="col-2">
              PP X X
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              Airport of Destination<br>
              INCHEON
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              Handling information
              <br>
              PLEASE NOTIFY THE CONSIGNEE IMMEDIATELY UPON ARRIVAL
              <br>
              DOCUMENT POUCH AND MANIFEST ATTACHED
            </div>
          </div>


          <div class="row">
            <div class="col-12">
              <button class="btn btn-primary" v-on:click="getHouseTotalData">Calculate</button>

              New GW: <input type="number" id="new-gw"/> New VW:<input type="number" id="new-vw"/> New CW: <input type="number" id="new-cw">
              <button class="btn btn-primary" v-on:click="changeManifestWeights">다시 계산하기</button>
            </div>
          </div>
          <div class="row">
            <div class="col-9">
              <table class="table">
                <tr>
                  <th>No</th>
                  <th>GW</th>
                  <th>Kg/lb</th>
                  <th>CW</th>
                  <th>Rate</th>
                  <th>Total</th>
                </tr>
                <tr>
                  <td>{{newManiItem.count}}</td>
                  <td>{{formatPrice((newManiItem.gw/100).toFixed(1))}}</td>
                  <td>K</td>
                  <td>{{formatPrice((newManiItem.cw/100).toFixed(1))}}</td>
                  <td>5.94</td>
                  <td>{{formatPrice((newManiItem.total/100).toFixed(2))}}</td>
                </tr>
                <tr>
                  <td colspan="6" class="text-center">
                    ***********************
                    <span><select style="width:200px; text-align:center;" v-model="newManiItem.cargo_type">
                      <option value="UNKNOWN CARGO">UNKNOWN CARGO</option>
                      <option value="KNOWN CARGO">KNOWN CARGO</option>
                    </select>
                    </span>
                    ********************
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="text-center">
                    24 HOURS CONTACT +44(0)7740646164
                  </td>
                </tr>
                <tr>
                  <td>{{newManiItem.count}}</td>
                  <td>{{formatPrice((newManiItem.gw/100).toFixed(1))}}</td>
                  <td colspan="4"></td>
                </tr>
              </table>

            </div>
            <div class="col-3">
              Nature and Quantity of Goods
              <textarea v-model="newManiItem.goodsDescription" rows="5" style="width: 100%;"/>
<!--              <br>-->
<!--              CONSOLIDATION CARGO-->
<!--              <br>-->
<!--              NON RESTRICTED-->
<!--              <br>-->
<!--              CARGO AS ADDRESSED-->
            </div>
          </div>

          <div class="row">
            <div class="col-4">

              <table class="table text-center">
                <tr>
                  <th>Prepaid</th>
                  <th colspan="2">Weight Change</th>
                  <th>Collect</th>
                </tr>
                <tr>
                  <th></th>
                  <th colspan="2">Valuation Charge</th>
                  <th></th>
                </tr>
                <tr>
                  <td colspan="2">{{formatPrice((newManiItem.total/100).toFixed(2))}}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th></th>
                  <th colspan="2">Tax</th>
                  <th></th>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th></th>
                  <th colspan="2">Total other Charges Due Agent</th>
                  <th></th>
                </tr>
                <tr>
                  <td colspan="2">{{formatPrice( ((Number(newManiItem.ahc)+Number(newManiItem.fsc)+Number(newManiItem.moc)+Number(newManiItem.avs))/100).toFixed(2))}}</td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <th></th>
                  <th colspan="2">Total other Charges Due Carrier</th>
                  <th></th>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td colspan="2"></td>
                </tr>

                <tr>
                  <th colspan="2">Total Prepaid</th>
                  <th colspan="2">Total Collect</th>
                </tr>
                <tr>
                  <td colspan="2">{{formatPrice( ((Number(newManiItem.total) + Number(newManiItem.ahc)+Number(newManiItem.fsc)+Number(newManiItem.moc)+Number(newManiItem.avs))/100).toFixed(2))}}</td>
                  <td colspan="2"></td>
                </tr>
              </table>
            </div>
            <div class="col-8">


              <div class="container">
                <div class="row">
                  <div class="col-12">
                    Other Charges
                    <br>
                    {{formatPrice( (newManiItem.total/100).toFixed(2))}}
                  </div>
                  <div class="col-4">
                    {{formatPrice( (newManiItem.ahc/100).toFixed(2))}} AHC (C)
                  </div>
                  <div class="col-4">
                    {{formatPrice( (newManiItem.fsc/100).toFixed(2))}} FSC (C)
                  </div>
                  <div class="col-4">
                    {{formatPrice( (newManiItem.moc/100).toFixed(2))}} MOC (C)
                  </div>
                  <div class="col-4">
                    {{formatPrice( (newManiItem.avs/100).toFixed(2))}} AVS (C)
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 text-center">
                    UTASCO LTD<br>
                    AS AGENTS FOR {{newManiItem.airlineTitle}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    Executed on (Date)
                    <input class="form-control" type="date" v-model="newManiItem.signedDate"/>

                  </div>
                  <div class="col-6">
                    signature
                    <input class="form-control" type="text" v-model="newManiItem.signedBy"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <b>Delivery Point Address</b>
              <input class="form-control" v-model="newManiItem.deliveryPointAddress1"/>
              <input class="form-control" v-model="newManiItem.deliveryPointAddress2"/>
              <input class="form-control" v-model="newManiItem.deliveryPointAddress3"/>
              <input class="form-control" v-model="newManiItem.deliveryPointAddress4"/>

            </div>
          </div>
          <div class="row">
            <div class="col-12" style="padding:10px;">
              <button class="btn btn-dark" v-on:click="printAwb(newManiItem.id)"><i class="fas fa-print"></i> Print AWB</button>

              <button class="btn btn-dark" style="margin-left:20px;" v-on:click="printDeliveryNote(newManiItem.id)"><i class="fas fa-print"></i> Print Delivery Note</button>
              Delivery Vehicle: <input type="text" style="width:200px;" v-model="newManiItem.vehicle_reg"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-item-form" v-if="editHouseItem != false">
      <div class="container">
        <div class="row">
          <h2 v-if="editHouseItem.id == 0">HOUSE 생성</h2>
          <h2 v-if="editHouseItem.id > 0">HOUSE #{{editHouseItem.ref}} 수정</h2>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group row">
              <div class="col-4"><label>#HOUSE:</label></div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.ref" placeholder="번호"/>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">DESCRIPTION:</div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.description"/>
              </div>

            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <div class="col-4"><label>NOP:</label></div>
              <div class="col-8">
                <input type="number" class="form-control" v-model="editHouseItem.nop" placeholder="NOP"/>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">WEIGHT:</div>
              <div class="col-8">
                <input type="number" class="form-control" v-model="editHouseItem.weight"/>
              </div>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group row">
              <div class="col-4">
                SHIPPER:
              </div>
              <div class="col-4">
                <select class="form-control" v-model="editHouseItem.shipper_id" @change="onHouseShipperSelectd()">
                  <option v-for="(item, index) in customers" :value="item.id">{{item.title}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">
                우편번호:
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.shipper_post_code"/>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">
                주소:
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.shipper_address_1"/>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">
                주소:
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.shipper_address_2"/>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">
                주소:
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.shipper_address_3"/>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <div class="col-4">
                CONSIGNEE:
              </div>
              <div class="col-4">
                <select class="form-control" v-model="editHouseItem.consignee_id" @change="onHouseConsigneeSelected">
                  <option v-for="(item, index) in forwarders" v-bind:value="item.id">{{item.title}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">
                우편번호:
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.consignee_post_code"/>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">
                주소:
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.consignee_address_1"/>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">
                주소:
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.consignee_address_2"/>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-4">
                주소:
              </div>
              <div class="col-8">
                <input type="text" class="form-control" v-model="editHouseItem.consignee_address_3"/>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="btn btn-secondary" v-on:click="closeHouseItemForm()">CLOSE</div>
          </div>
          <div class="col-6">
            <div v-if="editHouseItem.id ==0" class="btn btn-primary" v-on:click="submitHouseItemForm()">CREATE</div>
            <div v-if="editHouseItem.id > 0" class="btn btn-primary" v-on:click="submitHouseItemForm()">UPDATE</div>

          </div>
        </div>
      </div>
    </div>
    <transition name="vertical">
      <div class="new-item-form" v-if="editItem != false">
        <div class="scroll-container">
          <div class="container view-with-bottom-menu">
            <div class="row">
              <div class="col-12">
                <h2 v-if="editItem.id > 0">송장 수정 [{{editItem.awb}}]</h2>
                <h2 v-if="editItem.id == 0">송장 등록</h2>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="card">
                  <div class="card-header">
                    <h4>보내는사람</h4>
                  </div>
                  <div class="card-body">
                    <div class="container">
                      <div class="form-group row">
                        <div class="col-4">업체</div>
                        <div class="col-8">
                          <select class="form-control" v-model="editItem.customer_id" @change="senderSelected()">
                            <option value="0">직접입력</option>
                            <option v-for="(customer, index) in customers" :value="customer.id">
                              [{{customer.code}}]{{customer.title}}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">업체코드</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.code"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">보내는사람</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.sender"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">Address 1</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.sender_address_1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">Address 2</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.sender_address_2"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">POST CODE</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.sender_post_code"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">CONTACT</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.sender_contact"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="card">
                  <div class="card-header">
                    <h4>배송정보</h4>
                  </div>
                  <div class="card-body">
                    <div class="container">

                      <div class="form-group row">
                        <div class="col-4">배송일</div>
                        <div class="col-8">
                          <input type="date" class="form-control" v-model="editItem.dispatch_date"
                                 v-on:change="verifySendDate()" placeholder="Date"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">CT (개수)</div>
                        <div class="col-8">
                          <input type="number" class="form-control" v-model="editItem.ct"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">화주종류</div>
                        <div class="col-8">
                          <select class="form-control" v-model="editItem.seller_type">
                            <option value="2">회사</option>
                            <option value="1">개인</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">통관종류</div>
                        <div class="col-8">
                          <select class="form-control" v-model="editItem.custom_type">
                            <option value="목">목록통관</option>
                            <option value="일">일반통관</option>
                            <option value="간">간이통관</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">거래구분</div>
                        <div class="col-8">
                          <select class="form-control" v-model="editItem.trade_type">
                            <option value="A">전자상거래</option>
                            <option value="C">일반</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">관세청구</div>
                        <div class="col-4">
                          <select class="form-control" v-model="editItem.who_pays_tax">
                            <option value="0">Default</option>
                            <option value="1">수취인</option>
                            <option value="2">발송인</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">관세사비용청구</div>
                        <div class="col-4">
                          <select class="form-control" v-model="editItem.who_pays_inspection">
                            <option value="0">Default</option>
                            <option value="1">수취인</option>
                            <option value="2">발송인</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">배송메모</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.note"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">
                          VALUE(USD):
                        </div>
                        <div class="col-4">
                          <input type="number" class="form-control" v-model="editItem.value"
                                 placeholder="Product Value in USD" disabled/>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="card">
                  <div class="card-header">
                    <h4>받는사람</h4>
                  </div>
                  <div class="card-body">
                    <div class="container">

                      <div class="form-group row">
                        <div class="col-4">받는사람</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.receiver"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">통관번호</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.custom_number"/>
                        </div>
                      </div>

                      <div class="form-group row">
                        <div class="col-4">우편번호</div>
                        <div class="col-4">
                          <input type="text" class="form-control" v-model="editItem.post_code"/>
                        </div>
                        <div class="col-4">
                          <input type="button" class="btn btn-primary" value="주소검색" v-on:click="findAddress()"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">주소</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.address_1"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">상세주소</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.address_2"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">주민번호</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.national_id"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">연락처</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.receiver_contact"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">이메일</div>
                        <div class="col-8">
                          <input type="text" class="form-control" v-model="editItem.email"/>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" style="margin-top:10px;">
              <div class="card-header">
                <h4>물품 리스트</h4>
              </div>
              <div class="card-body">


                <div class="row">

                  <div class="col-12">
                    <table class="table">
                      <tr>
                        <th>원산지</th>
                        <th>브랜드</th>
                        <th>HS Code</th>
                        <th>상품명</th>
                        <th>수량</th>
                        <th>단가</th>
                        <th style="min-width: 100px;">총</th>
                        <th>상품URL</th>




                        <th v-if="useLiquid">액체류</th>
                      </tr>
                      <tr v-for="(item, index) in editItem.list">
                        <td>
                          <input type="text" class="form-control" v-model="item.origin_country"
                                 @input="item.origin_country = $event.target.value.toUpperCase()"/>
                          <!--                        <select class="form-control" v-model="item.origin_country">-->
                          <!--                          <option value="Select">Select</option>-->
                          <!--                          <option v-for="(item, index) in countries" :value="item.title">{{item.title}}</option>-->
                          <!--                        </select>-->
                        </td>
                        <td><input type="text" class="form-control" v-model="item.brand"
                                   @input="item.brand = $event.target.value.toUpperCase()"
                                   @keyup="checkBrandSpecialKey(index)"/></td>
                        <td>
                          <select class="form-control" v-model="item.hs_code">
                            <option value="-1">Select</option>
                            <option v-for="(code, index) in hsCodes" :value="code.textVal">({{code.textVal}}){{code.title}}
                            </option>
                          </select>
                        </td>
                        <td><input type="text" class="form-control" v-model="item.product"
                                   @input="item.product = $event.target.value.toUpperCase()"
                                   @keyup="onProductEntered(index)"/></td>
                        <td><input type="number" class="form-control" v-model="item.amount" @keypress="onlyNumber" pattern="[0-9]*" @keyup="calculateTotalValue"/></td>
                        <td><input type="number" class="form-control" v-model="item.value" @keyup="calculateTotalValue"/></td>
                        <td>{{item.amount*item.value}}</td>
                        <td><input type="text" class="form-control" @keyup="onProductEntered(index)" v-model="item.site_url"/></td>


                        <td v-if="useLiquid">
                          <select class="form-control" v-model="item.liquid">
                            <option value="0">No Liquid</option>
                            <option value="1">Liquid</option>
                          </select>
                        </td>
                      </tr>
                    </table>
                    <button type="button" class="btn btn-primary" v-on:click="onAddGood()">추가하기</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" style="margin-top:10px;">
              <div class="card-header">
                <h4>Size & Price</h4>
              </div>
              <div class="card-body">

                <div class="row">
                  <div class="col-4">
                    <div class="container">
                      <div class="form-group row">
                        <div class="col-4">Width</div>
                        <div class="col-4">
                          <input type="number" class="form-control" v-model="editItem.volume_x"
                                 v-on:change="onVolumeEntered()"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">Height</div>
                        <div class="col-4">
                          <input type="number" class="form-control" v-model="editItem.volume_y"
                                 v-on:change="onVolumeEntered()"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">Depth</div>
                        <div class="col-4">
                          <input type="number" class="form-control" v-model="editItem.volume_z"
                                 v-on:change="onVolumeEntered()"/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-4">
                    <div class="container">
                      <div class="form-group row">
                        <div class="col-4">부피무게</div>
                        <div class="col-4">
                          <input type="number" class="form-control" v-model="editItem.volume_weight/100" disabled/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">실무게</div>
                        <div class="col-4">
                          <input type="number" class="form-control" v-model="editItem.measured_weight"
                                 v-on:change="onVolumeEntered()"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">최종무게</div>
                        <div class="col-4">
                          <input type="number" class="form-control" v-model="editItem.weight/100" disabled/>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-4">
                    <div class="container">
                      <div class="form-group row">
                        <div class="col-4">기본요금</div>
                        <div class="col-4" style="padding-right:0;">
                          <input type="number" class="form-control text-right" v-model="editItem.base_price"
                                 v-on:change="onVolumeEntered()"/>
                        </div>
                        <div class="col-4 text-left" style="padding-left: 0;"> &nbsp;pence</div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">500g당 추가요금</div>
                        <div class="col-4" style="padding-right:0;">
                          <input type="number" class="form-control text-right" v-model="editItem.add_price"
                                 v-on:change="onVolumeEntered()"/>
                        </div>
                        <div class="col-4 text-left" style="padding-left: 0;"> &nbsp;pence</div>
                      </div>
                      <div class="form-group row">
                        <div class="col-4">최종요금</div>
                        <div class="col-4">
                          <h3>£{{(editItem.price/100).toFixed(2)}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>


              </div>
            </div>

            <div class="row fixed-bottom bottom-menu">
              <div class="col-6">
                <div class="bottom-button neutral-btn" v-on:click="closeEditItemForm()">Close</div>
              </div>
              <div class="col-6">
                <div v-if="editItem.id == 0" class="bottom-button positive-btn" v-on:click="submitEditItem()">생성</div>
                <div v-if="editItem.id > 0" class="bottom-button positive-btn" v-on:click="submitEditItem()">수정</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="vertical">
      <div class="receipt-container" v-if="showLabelPrint == true">
        <div class="receipt-inner-container">
          <div class="scroll-container">
            <iframe class="myiframe" id="label-print"  v-bind:class="{'iframe-a4-l': paperType==1 , 'iframe-a4-p': paperType == 2}" v-bind:src="labelHtml"
                    scrolling=yes
                    height="100%"
                    name="labelFrame"></iframe>

            <!--            <div class="label-container" id="label-print-embed"  v-bind:class="{'iframe-a4-l': paperType==1 , 'iframe-a4-p': paperType == 2}" v-html="labelHtml">-->

            <!--            </div>-->
            <!--          <div class="container" v-html="labelHtml">-->
            <!--          </div>-->
          </div>
          <span class="top-left-btn" v-on:click="closeLabelView"><i class="fas fa-window-close"></i>닫기</span>
        </div>
      </div>
    </transition>
    <div id="finder-container" class="fullscreen-container" style="z-index: 999;">
      <div id="postcodeFinderLayer" class="center-container">
        <img src="//t1.daumcdn.net/postcode/resource/images/close.png" id="btnCloseLayer"
             style="cursor:pointer;position:absolute;right:-3px;top:-3px;z-index:1" v-on:click="closeAddressFinder()"
             alt="닫기 버튼">
      </div>
    </div>
    <div class="spinner-container" v-if="isLoading">
      <div class="spinnermedium">
        <span class="bgtopl"><span class="highlighttopl"></span></span>
        <span class="bgtopr"><span class="highlighttopr"></span></span>
        <span class="bottomrow">
          <span class="bgbtml"><span class="highlightbtml"></span></span>
          <span class="bgbtmr"><span class="highlightbtmr"></span></span>
        </span>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>
<script>
    require('@/assets/css/styles.css')
    var XLSX = require('xlsx');
    import JsonExcel from "vue-json-excel";

    import Router from '../router';
    import VModal from '../router';
    import axios from 'axios';
    import AdminNav from '@/components/AdminNav';
    //import XLSX from 'xlsx'
    import moment from 'moment'
    import {getDepotCode, printHouseLabel, requestPrintLabel} from '../api/parcel'
    import {getHouseData} from "../api/general";
    import {
      getStateString,
      downloadFTADoc,
      getStateTimeString,
      getStatusString,
      millisToDate,
      convertToLocaleTime,
      moveToStatusPage,
      escapeLineChange,
      getTimeStamp,
      downloadFTADocMulti,
      playSound,
      playWarningSound,
      playWrongSound,
      getVersion,
      escapeSpecialCharacters
    } from '../api/Utils'


    export default {
        name: 'Home',
        componets: {
            AdminNav,
            JsonExcel,
        },
        data() {
            return {
                version:'',
                msg: 'Home',
                user: false,
                forwarders: [],
                countries: [],
                hsCodes: [],
                items: [],
                editItem: false,
                filter: {
                    forwarder: 0,
                    date_from: this.getTodayData(),
                    date_to: this.getTodayData(),
                    state: 0,
                    customer_id: 0,
                    awb: '',
                    receiver: '',
                    sender:'',
                },
                states: [
                    {state: 0, title: "송장작성"},
                    {state: 1, title: "1차 마감"},//Received and printed label
                    {state: 2, title: "2차 마감"},//Departed to airport
                    {state: 3, title: "3차 마감"},//On broad plane
                ],
                pageState: 0,
                isCheckAll: false,
                selectedItems: [],

                newManiItem: false,
                currentManifest: false,
                manifests: [],
                editHouseItem: false,
                customers: [],

                showAddressFinder: false,

                files: [],
                dropEnabled: false,
                state: {
                    tickets: [{name: "test"}],
                    headers: ["Test header"]
                },
                xls_fields: {
                    "수취인": "receiver",
                    "주소": "address",
                    "연락처": "contact",
                    "우편번호": "post_code",
                },
                inputList: [],
                barCode: '',

                isLoading: false,

                useLiquid: false,

                editMode: false,

                sortList: {
                    awb:false,
                    code:false,
                    dispatch_date:false,
                    receiver:false,
                    sender: false,
                    value:false,
                },
                showLabelPrint:false,
                labelHtml:false,
                paperType:0,
            }
        },
        created: function () {
            this.$data.version = getVersion();
            if(localStorage.getItem('id') == undefined || localStorage.getItem('id') == null || localStorage.getItem('id') === '') {
                Router.push('/admin');
                return;
            }
            document.addEventListener("backbutton", this.backHandler, false);
            this.$data.user = {
                id: localStorage.getItem('id'),
            }

            this.getSettingList();
            this.getPendingList();
            //this.getManifestList();
            this.getCustomerList();
            registerBackKeyHandler(this.backHandler);
            window.addEventListener('keydown', (e) => {
                // if (e.key == 'Escape') {
                //     this.showModal = !this.showModal;
                // }
                // console.log("Key input " + e.key);
                this.keyHandler(e.key);
                // 1234567890128

            });
        },
        beforeDestroy() {
            registerBackKeyHandler(false);
        },
        mounted: function () {
        },
        watch: {
            'editItem.note': function (newVal, oldVal) {
                if(this.$data.editItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.editItem.note = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
            'editItem.receiver': function (newVal, oldVal) {
                if(this.$data.editItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.editItem.receiver = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
            'editItem.address_1': function (newVal, oldVal) {
                if(this.$data.editItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.editItem.address_1 = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
            'editItem.address_2': function (newVal, oldVal) {
                if(this.$data.editItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.editItem.address_2 = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
            'editItem.sender': function (newVal, oldVal) {
                if(this.$data.editItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.editItem.sender = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
            'editItem.sender_address_1': function (newVal, oldVal) {
                if(this.$data.editItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.editItem.sender_address_1 = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
            'editItem.sender_address_2': function (newVal, oldVal) {
                if(this.$data.editItem == false) {
                    return;
                }
                if (newVal.includes('"') || newVal.includes("'")) {
                    this.$data.editItem.sender_address_2 = newVal.replace(/[^a-zA-Z ]/g, "");
                    this.showModal("에러", "특수문자는 사용할수 없숩니다");
                }
            },
        },
        methods: {
            formatPrice(value) {
              return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            onlyNumber ($event) {
                //console.log($event.keyCode); //keyCodes value
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

                console.log("key code " + keyCode);
                if (keyCode < 48 || keyCode > 57 || keyCode == 46) { // 46 is dot
                    console.log("prevent");
                    return $event.preventDefault();
                }
                console.log("not prevent");
            },
            customFormatter(date) {
                return moment(date).format('YYYY-MM-dd');
            },
            convertToUppercase: function (str) {
                // console.log("Convert " + str + " to upperCase");
                str = str.toUpperCase();
                // console.log("Converted " + str);
            },
            keyHandler: function (key) {
                if (key == 'Enter') {
                    if (this.$data.inputList.length == 13) {
                        console.log("Barcode entered");
                        this.$data.barCode = this.$data.inputList.join('');

                    } else {
                        console.log("Non barcode and entered");
                    }
                    console.log("Remove now");
                    this.$data.inputList = [];
                    return;
                }
                if (parseInt(key) != NaN) {
                    //Add to
                    // console.log("Number entered " + key);
                    this.$data.inputList.push(key);
                    if (this.$data.inputList.length > 13) {
                        console.log("Too long so remove");
                        this.$data.inputList = [];
                    }
                } else {
                    this.$data.inputList = [];
                    console.log("Non barcode input");
                }
            },
            forceFileDownload(response) {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'utasco-form-admin-template.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()
            },
            openStatusPage: function(awb) {
                moveToStatusPage(awb);
            },
            downloadForm: function () {
                var url = 'static/utasco-form-admin-template.xlsx';
                var self = this;
                console.log("Download form");
                axios({
                    method: 'get',
                    url: url,
                    responseType: 'arraybuffer'
                })
                    .then(response => {

                        self.forceFileDownload(response)

                    })
                    .catch(() => console.log('error occured'))
            },
            downloadForDWH: function () {
                var url = 'static/daewoon-form.xlsx';
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                var self = this;
                req.onload = function (e) {
                    var data = new Uint8Array(req.response);
                    var workbook = XLSX.read(data, {type: "array"});

                    /* DO SOMETHING WITH workbook HERE */
                    var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    var test = XLSX.utils.sheet_to_json(worksheet);
                    console.log("TEst data");
                    console.log(test);
                    var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                    console.log("Read data");
                    console.log(results);
                    var row = results[0];
                    var header = [];
                    for (var key in row) {
                        header.push(key);
                    }
                    var newList = [];
                    //newList.push(header);
                    for (var i = 0; i < self.$data.items.length; i++) {
                        var dataItem = self.$data.items[i];
                        let whoPaysFee = '수취인';
                        if(dataItem["who_pays_inspection"] == 2) {
                            whoPaysFee = '발송인';
                        }
                        var item = ["", dataItem["awb"], dataItem["dispatch_date"],
                            dataItem["sender"], dataItem["sender_contact"], dataItem["sender_post_code"], dataItem["sender_address_1"] + " " + dataItem["sender_address_2"],
                            dataItem["receiver"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem["post_code"], dataItem["address_1"], "", dataItem["custom_number"], dataItem['memo'],
                            (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"], whoPaysFee];


                        var list = self.$data.items[i].list;
                        for (var j = 0; j < list.length; j++) {
                            if(list[j].amount == 0) {
                                continue;
                            }
                            item.push(list[j].product);
                            item.push(list[j].amount);
                            item.push(list[j].value);
                            item.push(list[j].brand);
                            item.push(list[j].url);
                            item.push(list[j].hs_code);
                            item.push(list[j].origin_country);
                        }

                        newList.push(item);
                    }

                    XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                    var sheet = XLSX.utils.json_to_sheet(newList)

                    // A workbook is the name given to an Excel file
                    var wb = XLSX.utils.book_new() // make Workbook of Excel

                    // add Worksheet to Workbook
                    // Workbook contains one or more worksheets
                    XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                    // export Excel file
                    var fileName = "Daewoon-Upload-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                    XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                }

                req.send();
                console.log("DW form");


            },
          downloadForBridgeLogis: function () {
            var url = 'static/bridge-logis-form.xlsx';
            var req = new XMLHttpRequest();
            req.open("GET", url, true);
            req.responseType = "arraybuffer";

            var self = this;
            req.onload = function (e) {
              var data = new Uint8Array(req.response);
              var workbook = XLSX.read(data, {type: "array"});

              /* DO SOMETHING WITH workbook HERE */
              var worksheet = workbook.Sheets[workbook.SheetNames[0]];
              var test = XLSX.utils.sheet_to_json(worksheet);
              console.log("TEst data");
              console.log(test);
              var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
              console.log("Read data");
              console.log(results);
              var row = results[0];
              var header = [];
              for (var key in row) {
                header.push(key);
              }
              var newList = [];
              //newList.push(header);
              for (var i = 0; i < self.$data.items.length; i++) {
                var dataItem = self.$data.items[i];
                let whoPaysFee = '수취인';
                if(dataItem["who_pays_inspection"] == 2) {
                  whoPaysFee = '발송인';
                }

                // (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"]];


                var list = self.$data.items[i].list;
                for (var j = 0; j < list.length; j++) {

                  if(list[j].amount == 0) {
                    continue;
                  }
                  var item = [dataItem["code"],
                    dataItem["awb"],
                    dataItem["order_number"],
                    dataItem["sender"],
                    dataItem["sender_address_1"] + " " + dataItem["sender_address_2"],
                    dataItem["sender_contact"], //송하인 전화번호

                    // dataItem["trade_type"] //판매자유형
                    ];

                  let registeredInfoFound = false;
                  for(let i = 0 ; i < self.$data.customers.length ; i++) {
                    if(self.$data.customers[i].code == dataItem["code"]) {
                      item.push(self.$data.customers[i].registeredType);
                      if(self.$data.customers[i].registeredType === 'A') {
                        item.push(self.$data.customers[i].registeredCode);
                        item.push(self.$data.customers[i].registeredName);
                        item.push("");
                        item.push("");

                      } else if(self.$data.customers[i].registeredType === 'C') {

                        item.push("");
                        item.push("");
                        item.push(self.$data.customers[i].registeredCode);
                        item.push(self.$data.customers[i].registeredName);

                      } else {
                        item.push("");
                        item.push("");
                        item.push("");
                        item.push("");
                      }
                      registeredInfoFound = true;
                      break;
                    }
                  }
                  if(registeredInfoFound === false) {
                    item.push("");
                    item.push("");
                    item.push("");
                    item.push("");
                    item.push("");
                  }
                  item.push(dataItem["receiver"]); //수취인
                  item.push(dataItem["post_code"]); //우편번호
                  item.push(dataItem["address_1"]); //주소1
                  item.push(dataItem["address_2"]); //주소2
                  item.push(dataItem["receiver_contact"]); //전화번호
                  item.push(dataItem["receiver_contact"]); //휴대폰
                  item.push(dataItem["memo"]); //메모
                  item.push(dataItem["custom_number"]); //수취인 신분증번호

                  item.push("1"); //받는이구분

                  registeredInfoFound = false;
                  //구매대행등록번호
                  for(let i = 0 ; i < self.$data.customers.length ; i++) {
                    if(self.$data.customers[i].code == dataItem["code"]) {
                      // item.push(self.$data.customers[i].registeredType);
                      if(self.$data.customers[i].registeredType === 'B') {
                        item.push(self.$data.customers[i].registeredCode);

                      } else {
                        item.push("");

                      }
                      registeredInfoFound = true;
                      break;
                    }
                  }
                  if(registeredInfoFound === false) {
                    item.push("");
                  }
                  item.push(dataItem["trade_type"]); //통관구분
                  item.push("0"); //항목구분


                  // "Y",
                  //   dataItem["dispatch_date"], ,
                  //
                  //    "", "GB", dataItem["sender_post_code"],,
                  //
                  //   dataItem["receiver"], dataItem["post_code"], dataItem["address_1"], dataItem["address_2"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem['memo'],
                  //   dataItem["custom_number"], ""];


                  // let registeredInfoFound = false;

                  if(j > 0) {
                    let blanksize = item.length;
                    item = [];

                    for(let z = 0 ;z < blanksize ; z++ ) {
                      item.push("");
                    }
                  }
                  if(list[j].hs_code === undefined) {
                    self.showModal("에러", "송장 번호: " + self.$data.items[i].awb + " 물품 " + list[j].product + "의 HS code가 없습니다.");
                    return;
                  }
                  let hsCode = list[j].hs_code.toString();
                  if(hsCode.length === 1) {
                    hsCode = '0' + hsCode + '0000';
                  } else if(hsCode.length === 2) {
                    hsCode += '0000';
                  }
                  if(hsCode.length !== 6) {
                    self.showModal("에러", "송장 번호: " + self.$data.items[i].awb + " 물품 " + list[j].product + "의 HS code " + hsCode + ". HS CODE는 6자리입니다.");
                    return;
                  }
                  item.push(hsCode);
                  item.push((dataItem["measured_weight"] / 100).toFixed(2));
                  item.push(dataItem["ct"]);
                  item.push("");
                  item.push("");
                  item.push("");
                  item.push(list[j].product);
                  item.push(list[j].site_url);
                  item.push(list[j].amount);
                  item.push(list[j].value);

                  let itemValue = (parseFloat(list[j].value)*parseInt(list[j].amount)).toFixed(2);

                  item.push(itemValue);
                  // item.push(list[j].brand);

                  // item.push(whoPaysFee);
                  newList.push(item);
                  // item.push(list[j].origin_country);
                }


              }

              XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


              var sheet = XLSX.utils.json_to_sheet(newList)

              // A workbook is the name given to an Excel file
              var wb = XLSX.utils.book_new() // make Workbook of Excel

              // add Worksheet to Workbook
              // Workbook contains one or more worksheets
              XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

              // export Excel file
              var fileName = "Utasco-Brdige-Logis-Upload-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
              XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
            }

            req.send();
            console.log("DW form");


          },
            downloadForAllta: function () {
              var url = 'static/alta-form-3.xlsx';
              var req = new XMLHttpRequest();
              req.open("GET", url, true);
              req.responseType = "arraybuffer";

              var self = this;
              req.onload = function (e) {
                var data = new Uint8Array(req.response);
                var workbook = XLSX.read(data, {type: "array"});

                /* DO SOMETHING WITH workbook HERE */
                var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                var test = XLSX.utils.sheet_to_json(worksheet);
                console.log("TEst data");
                console.log(test);
                var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                console.log("Read data");
                console.log(results);
                var row = results[0];
                var header = [];
                for (var key in row) {
                  header.push(key);
                }
                var newList = [];
                //newList.push(header);
                for (var i = 0; i < self.$data.items.length; i++) {
                  var dataItem = self.$data.items[i];
                  let whoPaysFee = '수취인';
                  if(dataItem["who_pays_inspection"] == 2) {
                    whoPaysFee = '발송인';
                  }

                    // (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"]];


                  var list = self.$data.items[i].list;
                  for (var j = 0; j < list.length; j++) {

                    if(list[j].amount == 0) {
                      continue;
                    }
                    var item = ["", "", dataItem["awb"], dataItem["awb"], dataItem["dispatch_date"], dataItem["code"],

                      dataItem["sender"], dataItem["sender_address_1"] + " " + dataItem["sender_address_2"], "", "GB", dataItem["sender_post_code"],dataItem["sender_contact"],

                      dataItem["receiver"], dataItem["post_code"], dataItem["address_1"], dataItem["address_2"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem['memo'],
                       dataItem["custom_number"], "",

                      dataItem["trade_type"], "Y"];


                    let registeredInfoFound = false;
                    for(let i = 0 ; i < self.$data.customers.length ; i++) {
                      if(self.$data.customers[i].code == dataItem["code"]) {
                        item.push(self.$data.customers[i].registeredType);
                        if(self.$data.customers[i].registeredType === 'A') {
                          item.push(self.$data.customers[i].registeredCode);
                          item.push(self.$data.customers[i].registeredName);
                          item.push("");
                          item.push("");
                          item.push("");
                          item.push("");
                        } else if(self.$data.customers[i].registeredType === 'B') {
                          item.push("");
                          item.push("");
                          item.push(self.$data.customers[i].registeredCode);
                          item.push(self.$data.customers[i].registeredName);
                          item.push("");
                          item.push("");

                        } else if(self.$data.customers[i].registeredType === 'C') {
                          item.push("");
                          item.push("");

                          item.push("");
                          item.push("");
                          item.push(self.$data.customers[i].registeredCode);
                          item.push(self.$data.customers[i].registeredName);

                        } else if(self.$data.customers[i].registeredType === 'Z') {
                          item.push("");
                          item.push("");
                          item.push("");
                          item.push("");
                          item.push("");
                          item.push("");
                        }

                        registeredInfoFound = true;
                        break;
                      }
                    }
                    if(registeredInfoFound === false) {
                      item.push("Z");
                      item.push("");
                      item.push("");
                      item.push("");
                      item.push("");
                      item.push("");
                      item.push("");
                    }

                    item.push(dataItem["order_number"]);
                    if(j > 0) {
                      let blanksize = item.length;
                      item = [];

                      for(let z = 0 ;z < blanksize ; z++ ) {
                        item.push("");
                      }
                    }
                    if(list[j].hs_code === undefined) {
                      self.showModal("에러", "송장 번호: " + self.$data.items[i].awb + " 물품 " + list[j].product + "의 HS code가 없습니다.");
                      return;
                    }
                    let hsCode = list[j].hs_code.toString();
                    if(hsCode.length === 1) {
                      hsCode = '0' + hsCode + '0000';
                    } else if(hsCode.length === 2) {
                      hsCode += '0000';
                    }
                    if(hsCode.length !== 6) {
                      self.showModal("에러", "송장 번호: " + self.$data.items[i].awb + " 물품 " + list[j].product + "의 HS code " + hsCode + ". HS CODE는 6자리입니다.");
                      return;
                    }
                    item.push(hsCode);
                    item.push((dataItem["measured_weight"] / 100).toFixed(2));
                    item.push(dataItem["ct"])
                    item.push(list[j].product);
                    item.push(list[j].site_url);
                    item.push(list[j].amount);
                    item.push(list[j].value);

                    let itemValue = (parseFloat(list[j].value)*parseInt(list[j].amount)).toFixed(2);

                    item.push(itemValue);
                    item.push(list[j].brand);

                    item.push(whoPaysFee);
                    newList.push(item);
                    // item.push(list[j].origin_country);
                  }


                }

                XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                var sheet = XLSX.utils.json_to_sheet(newList)

                // A workbook is the name given to an Excel file
                var wb = XLSX.utils.book_new() // make Workbook of Excel

                // add Worksheet to Workbook
                // Workbook contains one or more worksheets
                XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                // export Excel file
                var fileName = "Alta-Korea-Upload-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
              }

              req.send();
              console.log("DW form");


            },
            downloadReport: function() {
                var url = 'static/report-detail.xlsx';
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                var self = this;
                req.onload = function (e) {
                    var data = new Uint8Array(req.response);
                    var workbook = XLSX.read(data, {type: "array"});

                    /* DO SOMETHING WITH workbook HERE */
                    var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    var test = XLSX.utils.sheet_to_json(worksheet);
                    console.log("TEst data");
                    console.log(test);
                    var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                    console.log("Read data");
                    console.log(results);
                    var row = results[0];
                    var header = [];
                    for (var key in row) {
                        header.push(key);
                    }
                    var newList = [];
                    //newList.push(header);
                    let orderCount = 0;
                    for (var i = 0; i < self.$data.items.length; i++) {
                        var dataItem = self.$data.items[i];


                        var list = self.$data.items[i].list;
                        let count = 0;
                        orderCount++;
                        let address = dataItem["address_1"];
                        if(dataItem["address_2"].length > 0) {
                            address += " " + dataItem["address_2"];
                        }
                        let details = "";
                        if(list != null && list.length > 0) {
                          let products = [];
                          for(let i = 0 ; i < list.length ; i++) {
                            if(list[i].product != undefined && list[i].product.length > 0) {
                              products.push(list[i].product);
                            }
                          }
                          if(products.length > 0) {
                            details = products.join(', ');
                          }
                        }
                        let item = [orderCount, dataItem["awb"], dataItem["dispatch_date"], dataItem["sender"], dataItem["receiver"], dataItem["ct"],
                            (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["volume_weight"] / 100).toFixed(2), (dataItem["price"]/100).toFixed(2), address, details];

                        newList.push(item);

                    }

                    XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                    var sheet = XLSX.utils.json_to_sheet(newList)

                    // A workbook is the name given to an Excel file
                    var wb = XLSX.utils.book_new() // make Workbook of Excel

                    // add Worksheet to Workbook
                    // Workbook contains one or more worksheets
                    XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                    // export Excel file
                    var fileName = "Report-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                    XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                }

                req.send();
                console.log("DW form");
            },
            downloadForDW2: function () {
                var url = 'static/daewoon-form-vertical.xlsx';
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                var defaultCellStyle = { font: { name: "Verdana", sz: 11, color: "FF00FF88"}, fill: {fgColor: {rgb: "FFFFAA00"}}};

                var workbook, wbout, wbin;

                workbook = {
                    "SheetNames": [
                        "Main"
                    ],
                    "Sheets": {
                        "Main": {
                            "A1": {
                                "v": "This is a submerged cell",
                                "s": {
                                    "border": {
                                        "left": {
                                            "style": "thick",
                                            "color": {
                                                "auto": 1
                                            }
                                        },
                                        "top": {
                                            "style": "thick",
                                            "color": {
                                                "auto": 1
                                            }
                                        },
                                        "bottom": {
                                            "style": "thick",
                                            "color": {
                                                "auto": 1
                                            }
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "B1": {
                                "v": "Pirate ship",
                                "s": {
                                    "border": {
                                        "top": {
                                            "style": "thick",
                                            "color": {
                                                "auto": 1
                                            }
                                        },
                                        "bottom": {
                                            "style": "thick",
                                            "color": {
                                                "auto": 1
                                            }
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "C1": {
                                "v": "Sunken treasure",
                                "s": {
                                    "border": {
                                        "right": {
                                            "style": "thick",
                                            "color": {
                                                "auto": 1
                                            }
                                        },
                                        "top": {
                                            "style": "thick",
                                            "color": {
                                                "auto": 1
                                            }
                                        },
                                        "bottom": {
                                            "style": "thick",
                                            "color": {
                                                "auto": 1
                                            }
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "D1": {
                                "v": "Blue",
                                "s": {
                                    "fill": {
                                        "fgColor": {
                                            "rgb": "FF0000FF"
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "E1": {
                                "v": "Theme 5",
                                "s": {
                                    "fill": {
                                        "fgColor": {
                                            "theme": 5
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "F1": {
                                "v": "Theme 5 Tint -0.5",
                                "s": {
                                    "fill": {
                                        "fgColor": {
                                            "theme": 5,
                                            "tint": -0.5
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "A2": {
                                "v": "Blank",
                                "t": "s"
                            },
                            "B2": {
                                "v": "Red",
                                "s": {
                                    "fill": {
                                        "fgColor": {
                                            "rgb": "FFFF0000"
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "C2": {
                                "v": "Green",
                                "s": {
                                    "fill": {
                                        "fgColor": {
                                            "rgb": "FF00FF00"
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "D2": {
                                "v": "Blue",
                                "s": {
                                    "fill": {
                                        "fgColor": {
                                            "rgb": "FF0000FF"
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "E2": {
                                "v": "Theme 5",
                                "s": {
                                    "fill": {
                                        "fgColor": {
                                            "theme": 5
                                        }
                                    }
                                },
                                "t": "s"
                            },
                            "F2": {
                                "v": "Theme 5 Tint -0.5",
                                "s": {
                                    "fill": {
                                        "fgColor": {
                                            "theme": 5,
                                            "tint": -0.5
                                        }
                                    }
                                },
                                "t": "s"
                            },
                        }
                    }
                }
                var fileName = "Daewoon-Upload-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                XLSX.writeFile(workbook, fileName, { defaultCellStyle: defaultCellStyle });
                // var self = this;
                // req.onload = function (e) {
                //     var data = new Uint8Array(req.response);
                //     var workbook = XLSX.read(data, {type: "array"});
                //
                //     /* DO SOMETHING WITH workbook HERE */
                //     var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                //     var test = XLSX.utils.sheet_to_json(worksheet);
                //     console.log("TEst data");
                //     console.log(test);
                //     var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                //     console.log("Read data");
                //     console.log(results);
                //     var row = results[0];
                //     var header = [];
                //     for (var key in row) {
                //         header.push(key);
                //     }
                //     var newList = [];
                //     //newList.push(header);
                //     let orderCount = 0;
                //     for (var i = 0; i < self.$data.items.length; i++) {
                //         var dataItem = self.$data.items[i];
                //
                //
                //         var list = self.$data.items[i].list;
                //         let count = 0;
                //         for (var j = 0; j < list.length; j++) {
                //             if(list[j].amount == 0 ) {
                //                 continue;
                //             }
                //             count++;
                //             orderCount++;
                //             let address = dataItem["address_1"];
                //             if(dataItem["address_2"].length > 0) {
                //                 address += " " + dataItem["address_2"];
                //             }
                //             var item = [orderCount, dataItem["awb"], dataItem["dispatch_date"],
                //                 dataItem["sender"], dataItem["sender_contact"], dataItem["sender_post_code"], dataItem["sender_address_1"] + " " + dataItem["sender_address_2"],
                //                 dataItem["receiver"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem["post_code"], address , dataItem["national_id"], dataItem["custom_number"], dataItem['note'],
                //                 (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"]];
                //             let countItem = {
                //                 v: count,
                //                 s:{
                //                     fill:{
                //                         bgColor:{
                //                             rgb:"FF0000FF"
                //                         }
                //                     }
                //                 }
                //             }
                //             item.push(countItem);
                //             //item.push(count);
                //             item.push(list[j].product);
                //             item.push(list[j].amount);
                //             item.push(list[j].value);
                //             item.push(list[j].brand);
                //             item.push(list[j].url);
                //             item.push(list[j].hs_code);
                //             item.push(list[j].origin_country);
                //
                //
                //             newList.push(item);
                //
                //         }
                //
                //
                //     }
                //
                //     XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});
                //
                //
                //     var sheet = XLSX.utils.json_to_sheet(newList)
                //
                //     // A workbook is the name given to an Excel file
                //     var wb = XLSX.utils.book_new() // make Workbook of Excel
                //
                //     // add Worksheet to Workbook
                //     // Workbook contains one or more worksheets
                //     XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet
                //
                //     // export Excel file
                //     var fileName = "Daewoon-Upload-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                //     XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                // }
                //
                // req.send();
                // console.log("DW form");


            },
            downloadForDW: function () {
                var url = 'static/daewoon-form-vertical.xlsx';
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                var self = this;
                req.onload = function (e) {
                    var data = new Uint8Array(req.response);
                    var workbook = XLSX.read(data, {type: "array"});

                    /* DO SOMETHING WITH workbook HERE */
                    var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    var test = XLSX.utils.sheet_to_json(worksheet);
                    console.log("TEst data");
                    console.log(test);
                    var results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                    console.log("Read data");
                    console.log(results);
                    var row = results[0];
                    var header = [];
                    for (var key in row) {
                        header.push(key);
                    }
                    var newList = [];
                    //newList.push(header);
                    let orderCount = 0;
                    for (var i = 0; i < self.$data.items.length; i++) {
                        var dataItem = self.$data.items[i];


                        var list = self.$data.items[i].list;
                        let count = 0;
                        let whoPaysFee = '수취인';
                        if(dataItem["who_pays_inspection"] == 2) {
                            whoPaysFee = '발송인';
                        }
                        for (var j = 0; j < list.length; j++) {
                            if(list[j].amount == 0 ) {
                                continue;
                            }
                            count++;
                            orderCount++;
                            let address = dataItem["address_1"];
                            if(dataItem["address_2"].length > 0) {
                                address += " " + dataItem["address_2"];
                            }
                            var item = [orderCount, dataItem["awb"], dataItem["dispatch_date"],
                                dataItem["sender"], dataItem["sender_contact"], dataItem["sender_post_code"], dataItem["sender_address_1"] + " " + dataItem["sender_address_2"],
                                dataItem["receiver"], dataItem["receiver_contact"], dataItem["receiver_contact"], dataItem["post_code"], address , dataItem["national_id"], dataItem["custom_number"], dataItem['note'],
                                (dataItem["measured_weight"] / 100).toFixed(2), (dataItem["weight"] / 100).toFixed(2), dataItem["ct"]];
                            let countItem = {
                                v: count,
                                s:{
                                    patternType: 'solid',
                                    bgColor:{
                                        rgb:"FF0000FF"
                                    }

                                },
                                t:"s"
                            }
                            item.push(countItem);
                            //item.push(count);
                            item.push(list[j].product);
                            item.push(list[j].amount);
                            item.push(list[j].value);
                            item.push(list[j].brand);
                            item.push(list[j].url);
                            item.push(list[j].hs_code);
                            item.push(list[j].origin_country);
                            item.push(whoPaysFee);


                            newList.push(item);

                        }


                    }

                    XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                    var sheet = XLSX.utils.json_to_sheet(newList)

                    // A workbook is the name given to an Excel file
                    var wb = XLSX.utils.book_new() // make Workbook of Excel

                    // add Worksheet to Workbook
                    // Workbook contains one or more worksheets
                    XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                    console.log(wb);
                    // export Excel file
                    var fileName = "Daewoon-Upload-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                    XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                }

                req.send();
                console.log("DW form");


            },
            downloadForSlx: function () {
                var xlsList = [];
                for (var i = 0; i < this.$data.items.length; i++) {

                    var item = {
                        "수취인": this.$data.items[i].receiver,
                        "주소": this.$data.items[i].address_1,
                        "연락처": this.$data.items[i].receiver_contact,
                        "우편번": this.$data.items[i].post_code,
                        "상품명": "",
                        "주문번호": "",
                        "상품내역": "",
                        "상품수량": "",
                        "배송메세제": "",
                    }
                    if (this.$data.items[i].address_2.length > 0) {
                        item["주소"] += " " + this.$data.items[i].address_2;
                    }

                    xlsList.push(item);
                }
                console.log(xlsList);
                var sheet = XLSX.utils.json_to_sheet(xlsList)

                // A workbook is the name given to an Excel file
                var wb = XLSX.utils.book_new() // make Workbook of Excel

                // add Worksheet to Workbook
                // Workbook contains one or more worksheets
                XLSX.utils.book_append_sheet(wb, sheet, 'sheet1') // sheetAName is name of Worksheet

                // export Excel file
                var fileName = moment(new Date()).format("SLX-Upload-YYYYMMDD-hhmmss") + '.xlsx';
                XLSX.writeFile(wb, fileName); // name of the file is book.xlsx

            },
            async buildXlsData() {
                console.log("buildXlsData");
                var xlsList = [];
                for (var i = 0; i < this.$data.items.length; i++) {

                    var item = {
                        "receiver": this.$data.items[i].receiver,
                        "address": this.$data.items[i].address_1,
                        "contact": this.$data.items[i].receiver_contact,
                        "post_code": this.$data.items[i].post_code,
                    }

                    xlsList.push(item);
                }
                console.log(xlsList);
                return xlsList;
            },
            startDownload() {
                alert('show loading');
            },
            finishDownload() {
                alert('hide loading');
            },
            logout: function () {
                let self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem('id');
                localStorage.removeItem('email');
                localStorage.removeItem('level');
                localStorage.removeItem('admin');
                localStorage.removeItem('password');
                Router.push('/admin');
            },
            getTotalAW: function () {
                var aw = 0;
                if (this.$data.items != false) {
                    for (var i = 0; i < this.$data.items.length; i++) {
                        aw += Number(this.$data.items[i].measured_weight);
                    }
                }

                return (aw / 100).toFixed(2);
            },
            dragEnter(e) {
                console.log("Drag Entered");
                this.$data.dropEnabled = true;
            },
            dragLeave(e) {
                console.log("dragLeave");
                this.$data.dropEnabled = false;
            },
            dragEnd(e) {
                console.log("dragEnd");
                this.$data.dropEnabled = false;
            },
            convertExcDateToString: function (excelDate) {

                var myDate = new Date((excelDate - (25567 + 2)) * 86400 * 1000);

                // = new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
                var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
                var date = ('0' + myDate.getDate()).slice(-2);
                var year = myDate.getFullYear();
                var formattedDate = year + '-' + month + '-' + date;
                return formattedDate;
                //return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
            },
            onfileselectorClick: function(){
                this.$refs.file.value = "";
                this.$refs.file.click()
            },
            addFilePickedUp(e) {
                console.log("addFilePickedUp");
                console.log(e)
                let self = this;
                if (e.target != undefined) {
                    if (e.target.files != undefined) {
                        let droppedFiles = e.target.files;
                        ([...droppedFiles]).forEach(f => {

                            var reader = new FileReader(),
                                name = f.name;

                            reader.onload = function (e) {
                                var results;
                                var data = e.target.result;


                                var fixedData = self.fixdata(data),
                                    workbook = XLSX.read(btoa(fixedData), {type: 'base64'}),
                                    firstSheetName = workbook.SheetNames[0],
                                    worksheet = workbook.Sheets[firstSheetName];
                                console.log("XLS read ");
                                console.log(workbook);
                                // return;
                                self.$data.state.headers = self.get_header_row(worksheet);
                                results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                                //self.$data.state.tickets=results;
                                console.log("Result");
                                //console.log(results);
                                var list = [];
                                var dispatchDate = '';
                                var stationCode = '';
                                var sender = '';
                                var senderAddress = '';
                                var senderPostCode = '';
                                var senderContact = '';
                                for (var i = 1; i < results.length; i++) {
                                    var result = results[i];
                                    // console.log("index " + i);
                                    // console.log(result);
                                    // console.log("dispatchDate " + result.dispatch_date + " length " + result.dispatch_date.length);
                                    if (result.dispatch_date > 4000) {
                                        dispatchDate = self.convertExcDateToString(result.dispatch_date);
                                    } else if (result.dispatch_date.length > 0) {
                                        console.log("dispatchDate length " + result.dispatch_date.length);
                                        if (result.dispatch_date.length == 10) {
                                            dispatchDate = result.dispatch_date;
                                        }
                                    }
                                    if (result.stationCode == undefined) {
                                        self.showModal("에러", "잘목된 양식입니다. 관리자용 엑셀파일이 아닌것 같습니다.");
                                        return;
                                    }
                                    if (result.stationCode.length == 4) {
                                        stationCode = result.stationCode;
                                    }
                                    let customerId = 0;
                                    for(let i = 0 ; i < self.$data.customers.length ; i++) {
                                        if(self.$data.customers[i].code == stationCode) {
                                            customerId = self.$data.customers[i].id;
                                            break;
                                        }
                                    }

                                    if(customerId == 0) {
                                        self.showModal("에러", "존재하지 않는 Station Code입나다.");
                                        return;
                                    }
                                    if (result.sender_address.length > 0) {
                                        senderAddress = result.sender_address;
                                    }
                                    if (result.sender_post_code.length > 0) {
                                        senderPostCode = result.sender_post_code;
                                    }
                                    if (result.sender_contact.length > 0) {
                                        senderContact = result.sender_contact;
                                    }
                                    if (result.sender.length > 0) {
                                        sender = result.sender;
                                    }
                                    if (result.seller_type == "") {
                                        result.seller_type = "2";
                                    }
                                    if (result.trade_type == "") {
                                        result.trade_type = "A";
                                    }
                                    if (result.custom_type == "") {
                                        result.custom_type = "목";
                                    }
                                    let item = {
                                        code: stationCode,
                                        customer_id: customerId,
                                        dispatch_date: dispatchDate,//self.convertExcDateToString(dispatchDate),
                                        sender: result.sender,
                                        sender_address_1: senderAddress,
                                        sender_address_2: '',
                                        sender_post_code: senderPostCode,
                                        sender_contact: senderContact,
                                        receiver: result.receiver,
                                        address_1: escapeLineChange(result.address),
                                        receiver_contact: result.contact,
                                        post_code: result.post_code,
                                        custom_number: result.custom_id,
                                        seller_type: result.seller_type,
                                        custom_type: result.custom_type,
                                        trade_type: result.trade_type,
                                        note: escapeLineChange(result.message),
                                        forwarder_id: 4,
                                        list: '',

                                    };
                                    if(item.post_code.length == 4) {
                                        item.post_code = "0" + item.post_code;
                                    }
                                    var totalValue = 0;
                                    var itemList = [];
                                    for (var k = 1; k <= 30; k++) {
                                        var productKey = "item" + k;
                                        var amountKey = "amount" + k;
                                        var hsCodeKey = "hscode" + k;
                                        //var
                                        console.log("Item " + k)
                                        if(result["item" + k] == undefined) {
                                          console.log("cannot find item" + k )
                                          continue;
                                        }
                                        // console.log("item " + k + " " + result["item" + k].length);
                                        // console.log("amount " + result["amount" + k]);
                                        // console.log("hscode " + result["hscode" + k]);

                                        if (result["item" + k].length > 0 && result["amount" + k] > 0 && result["hscode" + k] !== null) {
                                          if(result["hscode" + k].length !== 6) {
                                            self.showModal("에러", "HS CODE는 6자리입니다..");
                                            return;
                                          }
                                            console.log("here");
                                            var good = {
                                                product: escapeSpecialCharacters(result["item" + k]),
                                                brand: escapeSpecialCharacters(result["brand" + k]),
                                                url: escapeSpecialCharacters(result["url" + k]),
                                                hs_code: result["hscode" + k],
                                                amount: result["amount" + k],
                                                value: result["value" + k],
                                                origin_country: escapeSpecialCharacters(result["origin_country" + k]),
                                            };
                                            totalValue += parseFloat(result["value" + k])*parseInt(result["amount" + k]);
                                            // good["liquid"] = 0;
                                            // if (result["liquid" + k].length > 0) {
                                            //     good["liquid"] = result["liquid" + k];
                                            // }
                                            // console.log(good);
                                            itemList.push(good);
                                        }

                                    }
                                    item["list"] = JSON.stringify(itemList);
                                    item["value"] = totalValue;
                                    // console.log(item);
                                    list.push(item);


                                }
                                self.createList(list);

                            }
                            reader.readAsArrayBuffer(f);


                        });
                    }
                }
            },
            addFile(e) {
                this.$data.dropEnabled = false;
                var self = this;
                e.stopPropagation();
                e.preventDefault();
                let droppedFiles = e.dataTransfer.files;
                console.log("Add File");
                console.log(droppedFiles);
                if (!droppedFiles) return;
                // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
                ([...droppedFiles]).forEach(f => {

                    var reader = new FileReader(),
                        name = f.name;

                    reader.onload = function (e) {
                        var results;
                        var data = e.target.result;


                        var fixedData = self.fixdata(data),
                            workbook = XLSX.read(btoa(fixedData), {type: 'base64'}),
                            firstSheetName = workbook.SheetNames[0],
                            worksheet = workbook.Sheets[firstSheetName];
                        self.$data.state.headers = self.get_header_row(worksheet);
                        results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                        //self.$data.state.tickets=results;
                        console.log("Result");
                        //console.log(results);
                        var list = [];
                        var dispatchDate = '';
                        var stationCode = '';
                        var sender = '';
                        var senderAddress = '';
                        var senderPostCode = '';
                        var senderContact = '';
                        for (var i = 1; i < results.length; i++) {
                            var result = results[i];
                            console.log("index " + i);
                            console.log(result);
                            console.log("dispatchDate " + result.dispatch_date + " length " + result.dispatch_date.length);
                            if (result.dispatch_date > 4000) {
                                dispatchDate = self.convertExcDateToString(result.dispatch_date);
                            } else if (result.dispatch_date.length > 0) {
                                console.log("dispatchDate length " + result.dispatch_date.length);
                                if (result.dispatch_date.length == 10) {
                                    dispatchDate = result.dispatch_date;
                                }
                            }
                            if (result.stationCode == undefined) {
                                self.showModal("에러", "잘목된 양식입니다. 관리자용 엑셀파일이 아닌것 같습니다.");
                                return;
                            }
                            if (result.stationCode.length == 4) {
                                stationCode = result.stationCode;
                            }
                            if (result.sender_address.length > 0) {
                                senderAddress = result.sender_address;
                            }
                            if (result.sender_post_code.length > 0) {
                                senderPostCode = result.sender_post_code;
                            }
                            if (result.sender_contact.length > 0) {
                                senderContact = result.sender_contact;
                            }
                            if (result.sender.length > 0) {
                                sender = result.sender;
                            }
                            if (result.seller_type == "") {
                                result.seller_type = "2";
                            }
                            if (result.trade_type == "") {
                                result.trade_type = "A";
                            }
                            if (result.custom_type == "") {
                                result.custom_type = "목";
                            }

                            let customerId = 0;
                            for(let i = 0 ; i < self.$data.customers.length ; i++) {
                              if(self.$data.customers[i].code == stationCode) {
                                customerId = self.$data.customer[i].id;
                                break;
                              }
                            }

                            if(customerId == 0) {
                              self.showModal("에러", "존재하지 않는 Station Code입나다.");
                              return;
                            }
                            let item = {
                                code: stationCode,
                                customer_id: customerId,
                                dispatch_date: dispatchDate,//self.convertExcDateToString(dispatchDate),
                                sender: result.sender,
                                sender_address_1: senderAddress,
                                sender_address_2: '',
                                sender_post_code: senderPostCode,
                                sender_contact: senderContact,
                                receiver: result.receiver,
                                address_1: result.address,
                                receiver_contact: result.contact,
                                post_code: result.post_code,
                                custom_number: result.custom_id,
                                seller_type: result.seller_type,
                                custom_type: result.custom_type,
                                trade_type: result.trade_type,
                                note: result.message,
                                forwarder_id: 4,
                                list: '',

                            };
                            var totalValue = 0;
                            var itemList = [];
                            for (var k = 1; k <= 50; k++) {
                                var productKey = "item" + k;
                                var amountKey = "amount" + k;
                                var hsCodeKey = "hscode" + k;
                                //var
                                console.log("item " + k + " " + result["item" + k].length);
                                console.log("amount " + result["amount" + k]);
                                console.log("hscode " + result["hscode" + k]);


                                if (result["item" + k].length > 0 && result["amount" + k] > 0 && result["hscode" + k] !== null && result["hscode" + k].length > 0) {
                                    if(result["hscode" + k] !== undefined && result["hscode" + k].length > 0) {
                                      if(result["hscode" + k].length !== 6) {
                                        self.showModal("에러", "HS CODE는 6자리입니다..");
                                      }
                                    }
                                    console.log("here");
                                    var good = {
                                        product: result["item" + k],
                                        brand: result["brand" + k],
                                        url: result["url" + k],
                                        hs_code: result["hscode" + k],
                                        amount: result["amount" + k],
                                        value: result["value" + k],
                                        origin_country: result["origin_country" + k],
                                    };
                                    totalValue += parseInt(result["value" + k]);
                                    // good["liquid"] = 0;
                                    // if (result["liquid" + k].length > 0) {
                                    //     good["liquid"] = result["liquid" + k];
                                    // }
                                    console.log(good);
                                    itemList.push(good);
                                }
                            }
                            item["list"] = JSON.stringify(itemList);
                            item["value"] = totalValue;
                            console.log(item);
                            list.push(item);


                        }
                        self.createList(list);

                    }
                    reader.readAsArrayBuffer(f);


                });
            },
            get_header_row: function (sheet) {
                var headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
                //range.s.r = 2;//XLSX.utils.decode_row("3");
                var C, R = range.s.r; /* start in the first row */
                for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
                    var cell = sheet[XLSX.utils.encode_cell({c: C, r: R})] /* find the cell in the first row */
                    var hdr = "UNKNOWN " + C; // <-- replace with your desired default
                    if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
                    headers.push(hdr);
                }
                return headers;
            },
            fixdata: function (data) {
                var o = "", l = 0, w = 10240;
                for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
                o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
                return o;
            },
            workbook_to_json: function (workbook) {
                var result = {};
                workbook.SheetNames.forEach(function (sheetName) {
                    var roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                    if (roa.length > 0) {
                        result[sheetName] = roa;
                    }
                });
                return result;
            },
            backHandler: function () {
                console.log("Admin Main back pressed");
                if (this.$data.newManiItem != false) {
                    this.$data.newManiItem = false;
                    return;
                }
                if (this.$data.editItem != false) {
                    this.$data.editItem = false;
                    return;
                }
            },
            getSettingList: function () {
                var self = this;
                console.log("getForwarderList");
                var url = process.env.APP_URL + 'api/get_customer_meta.php?customer_id=' + this.$data.user.id;
                axios.get(url)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success) {
                            self.$data.forwarders = data.forwarders;
                            console.log("forwarders set");
                            console.log(self.$data.forwarders);
                            self.$data.countries = data.countries;
                            self.$data.hsCodes = data.hs_code;
                        }
                    })
                    .catch(error => {

                    });
            },
            // getTodayData: function () {
            //     var myDate = new Date();
            //     var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
            //     var date = ('0' + myDate.getDate()).slice(-2);
            //     var year = myDate.getFullYear();
            //     var formattedDate = year + '-' + month + '-' + date;
            //     return formattedDate;
            // },
            showModal: function (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            getForwarderList: function () {
                var self = this;
                var url = process.env.APP_URL + 'api/get_forwarders.php';
                console.log("getForwarderList");
                axios.get(url)
                    .then(response => {
                        console.log("Get Forwarders");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.forwarders = data.items;
                        } else {

                        }
                    })
                    .catch(error => {

                    });
            },
            addSelectField: function () {
                for (var i = 0; i < this.$data.items.length; i++) {
                    this.$data.items[i].selected = false;
                }
            },
            selectAll: function () {
                this.$data.isCheckAll = !this.$data.isCheckAll;
                this.$data.selectedItems = [];
                //var unselectableFound = false;
                if (this.$data.isCheckAll) {
                    for (var key in this.$data.items) {
                        this.$data.selectedItems.push(key)
                        // if (this.$data.items[key].price > 0) {
                        //
                        // } else {
                        //     //unselectableFound = true;
                        // }
                    }
                }
                // if (unselectableFound) {
                //     this.showModal("WARNING", "아직 무게 측정이 되지 않은 아이템들은 선택되지 않았습니다.");
                // }
            },
            updateCheckall: function (e, index) {
                console.log("updateCheckall");
                if (e.shiftKey) {
                    console.log("shif key clicked");
                    let lastIndex = 0;
                    if(this.$data.selectedItems.length > 0) {
                        lastIndex = this.$data.selectedItems[this.$data.selectedItems.length-1];
                    }

                    if(index > lastIndex) {
                        for(let i = lastIndex+1 ; i < index ; i++) {
                            let found = false;
                            for(let j = 0 ; j < this.$data.selectedItems.length ; j++) {
                                if(this.$data.selectedItems[j] === i) {
                                    this.$data.selectedItems.splice(j, 1);
                                    found = true;
                                    break;
                                }
                            }
                            if(found == false) {
                                this.$data.selectedItems.push(i);
                            }
                        }
                    } else {
                        for(let i = index+1 ; i < lastIndex ; i++) {
                            let found = false;
                            for(let j = 0 ; j < this.$data.selectedItems.length ; j++) {
                                if(this.$data.selectedItems[j] === i) {
                                    this.$data.selectedItems.splice(j, 1);
                                    found = true;
                                    break;
                                }
                            }
                            if(found == false) {
                                this.$data.selectedItems.push(i);
                            }
                        }
                    }
                }
                if (this.$data.selectedItems.length == this.$data.items.length) {
                    this.$data.isCheckAll = true;
                } else {
                    this.$data.isCheckAll = false;
                }
                let self = this;
                console.log("check ");
                console.log(this.$data.selectedItems);
                // for (let i = 0; i < this.$data.selectedItems.length; i++) {
                //     if (this.$data.selectedItems[i] == index && this.$data.items[index].price <= 0) {
                //
                //         console.log(this.$data.selectedItems);
                //         setTimeout(function () {
                //             self.$data.selectedItems.splice(i, 1);
                //             self.$data.items[index].selected = false;
                //         }, 100);
                //         this.$modal.show('dialog', {
                //             title: "ERROR",
                //             clickToClose: false,
                //             text: "무게측정이 되지 않은 송장입니다.",
                //             buttons: [
                //                 {
                //                     title: 'Close',
                //                     handler: () => {
                //                         self.$modal.hide('dialog');
                //
                //                     }
                //                 }
                //             ]
                //         });
                //
                //         return;
                //     }
                // }

                console.log(this.$data.selectedItems);
            },
            createList: function (list) {
                console.log("createList");
                var data = {
                    "list": list
                }
                var self = this;
                var url = process.env.APP_URL + 'api/create_items.php';
                axios.post(url, data)
                    .then(response => {
                        var data = response.data;
                        console.log(data);
                        if (data.success) {
                            var items = data.items;
                            for (var i = 0; i < items.length; i++) {
                                items[i].list = JSON.parse(items[i].list);
                                self.$data.items.push(items[i]);
                            }

                        } else {
                            console.log("Error " + data.message);
                        }
                    })
                    .catch(error => {

                    });
            },
            getPendingList: function () {
                var self = this;
                this.pageState = 0;
                var url = process.env.APP_URL + 'api/get_items_admin.php?user_id=' + this.$data.user.id + '&state=0';
                console.log("URL " + url);
                axios.get(url)
                    .then(response => {
                        console.log("Get Pending");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                          for(let i = 0 ; i < data.items.length ; i++) {

                            if(data.items[i].list !== null && data.items[i].list.length > 0 && data.items[i].list.startsWith('"\"') && data.items[i].list.endsWith('\""')) {
                              data.items[i].list = data.items[i].list.slice(2, -2);
                            }
                            if(data.items[i].list !== null && data.items[i].list.length > 0 && data.items[i].list.startsWith('"') && data.items[i].list.endsWith('"')) {
                              data.items[i].list = data.items[i].list.slice(1, -1);
                            }
                          }
                            self.$data.items = data.items;
                            self.$data.items.sort(function (a, b) {
                                if (a.dispatch_date > b.dispatch_date) {
                                    return 1;
                                }
                                return -1;
                            })
                            console.log("Pending list acquired");
                            for (var i = 0; i < self.$data.items.length; i++) {
                                if (self.$data.items[i].list == '') {
                                    self.$data.items[i].list = [];
                                } else {
                                  if(self.$data.items[i].awb === '6078062823334') {
                                    console.log(self.$data.items[i].awb);
                                    console.log(JSON.stringify(self.$data.items[i].list));
                                  }
                                  if(self.$data.items[i].list.match("\\r\\n")) {
                                    console.log("RN found");
                                    self.$data.items[i].list = self.$data.items[i].list.replace("\\r\\n","");
                                    console.log("RN found" + self.$data.items[i].awb);
                                    console.log(JSON.stringify(self.$data.items[i].list));
                                  }
                                  if(self.$data.items[i].list.match(/\r/g)) {
                                    console.log("ashdjadsas");
                                    self.$data.items[i].list = self.$data.items[i].list.replace(/\r/g,"");
                                  }
                                  if(self.$data.items[i].list.match("\\r")) {
                                    console.log("ashdjadsas");
                                    self.$data.items[i].list = self.$data.items[i].list.replace(/\\r/g,"");
                                  }
                                  if(self.$data.items[i].list.match(/\n/g)) {
                                    console.log("LINEBREAK FOUND");
                                    self.$data.items[i].list = self.$data.items[i].list.replace(/\n/g,"");
                                  }
                                  if(self.$data.items[i].list.match("\\n")) {
                                    console.log("LINEBREAK FOUND");
                                    self.$data.items[i].list = self.$data.items[i].list.replace(/\\n/g,"");
                                  }
                                  if(self.$data.items[i].list.match("\n")) {
                                    console.log("LINEBREAK FOUND");
                                    self.$data.items[i].list = self.$data.items[i].list.replace("\n","");
                                  }


                                  if(self.$data.items[i].list.match("\\t")) {
                                    console.log("TAB FOUND");
                                    self.$data.items[i].list = self.$data.items[i].list.replace("\\t","");
                                    console.log("TAB REMOVED " + self.$data.items[i].awb);
                                    console.log(JSON.stringify(self.$data.items[i].list));
                                  }

                                    self.$data.items[i].list = JSON.parse(self.$data.items[i].list);
                                }

                            }
                            self.addSelectField();

                        } else {

                        }
                    })
                    .catch(error => {
                      console.log(error);
                    });
            },
            getCustomerList: function () {
                var self = this;
                this.pageState = 0;
                var url = process.env.APP_URL + 'api/get_customers.php?';
                axios.get(url)
                    .then(response => {
                        console.log("Get Customers");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.customers = data.list.customer;
                            console.log(self.$data.customers);


                        } else {

                        }
                    })
                    .catch(error => {

                    });
            },
            getManifestList: function () {
                var url = process.env.APP_URL + 'api/get_manifest.php?date_from=' + this.$data.filter.date_from + '&date_to=' + this.$data.filter.date_to;
                var self = this;
                this.$data.manifests = [];
                console.log("getManifestList " + url);
                axios.get(url)
                    .then(response => {
                        console.log("Get Manifests");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.pageState = this.$data.filter.state;
                            self.$data.manifests = data.items;
                            for (var i = 0; i < self.$data.manifests.length; i++) {
                                if (self.$data.manifests[i].list == '') {
                                    self.$data.manifests[i].list = [];
                                } else {
                                    self.$data.manifests[i].list = JSON.parse(self.$data.manifests[i].list);
                                }
                            }

                        } else {

                        }
                    })
                    .catch(error => {

                    });
            },
            onManifesetSelected: function (index) {

                this.$data.currentManifest = this.$data.manifests[index];
                if (this.$data.manifests[index].list.length == 0) {

                }
            },
            onManifestEditClicked: function (index) {
                //this.$data.newManiItem = JSON.parse(JSON.stringify(this.$data.manifests[index]));
                let self = this;
                var url = process.env.APP_URL + 'api/get_manifest_item.php?id=' + this.$data.manifests[index].id;
                axios.get(url)
                .then(function(response) {
                  console.log(response);
                  let data = response.data;

                  if(data.success == true) {
                    if(data.item.list == undefined || data.item.list === '') {
                      data.item.list = [];
                    } else {
                      console.log(JSON.stringify(data.item.list));
                      // if(data.item.list.indexOf("\n") !== -1) {
                      data.item.list = data.item.list.replace(/\n/g, "\\n");
                      // }
                      console.log(JSON.stringify(data.item.list));
                      data.item.list = JSON.parse(data.item.list);
                    }
                    for(let i = 0 ; i < data.item.list.length ; i++) {
                      if(data.item.list[i].memo === undefined) {
                        data.item.list[i].memo = "";
                      }
                      data.item.list[i].memo = data.item.list[i].memo.replace(/\\n/g, "\n");

                    }
                    data.item.departure_time = convertToLocaleTime(data.item.departure_time);
                    data.item.arrival_time = convertToLocaleTime(data.item.arrival_time);
                    self.$data.newManiItem = data.item;

                    console.log(self.$data.newManiItem);

                    self.addNewHouseItem();
                  }
                })
                .catch(function(err) {
                  console.log(err);
                  if(err.response != undefined) {
                    console.log(err.response);
                  }
                })

            },
            validateHouse: function () {
                if (this.$data.newManiItem == false) {
                    return false;
                }
                if (this.$data.newManiItem.list.length == 0) {
                    this.showModal("ERROR", "House를 추가해주세요");
                    return false;
                }

                console.log(this.$data.newItem.list);
                for (var i = this.$data.newItem.list.length - 1; i >= 0; i--) {

                    if (this.$data.newManiItem.list[i].nop.length == 0 ||
                        this.$data.newManiItem.list[i].nop == 0 ||
                        this.$data.newManiItem.list[i].weight.length == 0 ||
                        this.$data.newManiItem.list[i].weight == 0 ||
                        this.$data.newManiItem.list[i].house_ref.length == 0) {
                        this.$data.newItem.list.splice(i, 1);

                    }
                }
                if (this.$data.newItem.list.length == 0) {
                    this.showModal("ERROR", "물품을 추가해주세요");
                    return false;
                }
                this.countManiTotalWeight();
                return true;
            },
            getDayCodeFromDate: function (day) {
                var d = new Date(day);
                var n = d.getDay();
                if (n == 0) {
                    return 'G';
                } else if (n == 1) {
                    return 'A';
                } else if (n == 2) {
                    return 'B';
                } else if (n == 3) {
                    return 'C';
                } else if (n == 4) {
                    return 'D';
                } else if (n == 5) {
                    return 'E';
                } else if (n == 6) {
                    return 'G';
                }
                return 'Z';
            },
            addNewHouseItem: function (forceToAdd = false) {
                if (this.$data.newManiItem == false) {
                    return;
                }

                if (this.$data.newManiItem.list == '') {
                    this.$data.newManiItem.list = [];
                }
                if (this.$data.newManiItem.list.length == 0 || forceToAdd) {

                    var houseRef = 'UT' + this.getDayCodeFromDate(this.$data.newManiItem.cargo_date);
                    houseRef += ' ' + this.$data.newManiItem.cargo_date.replace(/-/g, '').substring(2);
                    houseRef += ' ' + (this.$data.newManiItem.list.length + 1);
                    var newHouseItem = {
                        id: 0,
                        ref: this.$data.newManiItem.list.length + 1,
                        manifest_id: this.$data.newManiItem.id,
                        house_ref: houseRef,
                        description: '',
                        nop: 0,
                        dest: '',
                        weight: 0,
                        shipper_id: 0,
                        shipper_title: '',
                        shipper_address_1: '',
                        shipper_address_2: '',
                        shipper_address_3: '',
                        shipper_post_code: '',
                        consignee_id: 0,
                        consignee_title: '',
                        consignee_address_1: '',
                        consignee_address_2: '',
                        consignee_address_3: '',
                        consignee_post_code: '',
                        memo:'',
                    };
                    this.$data.newManiItem.list.push(newHouseItem);
                }
            },
            getForwarderById: function (id) {
                if (this.$data.forwarders.list == 0) {
                    return false;
                }
                for (var i = 0; i < this.$data.forwarders.length; i++) {
                    if (this.$data.forwarders[i].id == id) {
                        return this.$data.forwarders[i];
                    }
                }
                return false;
            },
            getCustomerById: function (id) {
                if (this.$data.customers.list == 0) {
                    return false;
                }
                for (var i = 0; i < this.$data.customers.length; i++) {
                    if (this.$data.customers[i].id == id) {
                        return this.$data.customers[i];
                    }
                }
                return false;
            },
            houseConsigneeChanged: function (index) {
                if (this.$data.newManiItem == false) {
                    return;
                }

                this.$data.newManiItem.list[index].consignee_title = "";
                this.$data.newManiItem.list[index].consignee_address_1 = "";
                this.$data.newManiItem.list[index].consignee_address_2 = "";
                this.$data.newManiItem.list[index].consignee_post_code = "";
                var forwarder = this.getForwarderById(this.$data.newManiItem.list[index].consignee_id);
                if (forwarder != false) {
                    this.$data.newManiItem.list[index].consignee_title = forwarder.title;
                    this.$data.newManiItem.list[index].consignee_address_1 = forwarder.address_1;
                    this.$data.newManiItem.list[index].consignee_address_2 = forwarder.address_2;
                    this.$data.newManiItem.list[index].consignee_post_code = forwarder.post_code;
                }
            },
            houseShipperChanged: function (index) {
                if (this.$data.newManiItem == false) {
                    return;
                }

                this.$data.newManiItem.list[index].shipper_title = "";
                this.$data.newManiItem.list[index].shipper_address_1 = "";
                this.$data.newManiItem.list[index].shipper_address_2 = "";
                this.$data.newManiItem.list[index].shipper_post_code = "";
                var customer = this.getCustomerById(this.$data.newManiItem.list[index].shipper_id);
                if (customer != false) {
                    this.$data.newManiItem.list[index].shipper_title = customer.title;
                    this.$data.newManiItem.list[index].shipper_address_1 = customer.address_1;
                    this.$data.newManiItem.list[index].shipper_address_2 = customer.address_2;
                    this.$data.newManiItem.list[index].shipper_post_code = customer.post_code;
                }
            },
            createNewHouseForm: function () {
                if (this.$data.newManiItem == false) {
                    return;
                }
                this.$data.editHouseItem = {
                    id: 0,
                    manifest_id: this.$data.newManiItem.id,
                    house_ref: '',
                    description: '',
                    nop: 0,
                    dest: '',
                    weight: 0,
                    shipper_id: 0,
                    shipper_title: '',
                    shipper_address_1: '',
                    shipper_address_2: '',
                    shipper_address_3: '',
                    shipper_post_code: '',
                    consignee_id: 0,
                    consignee_title: '',
                    consignee_address_1: '',
                    consignee_address_2: '',
                    consignee_address_3: '',
                    consignee_post_code: '',
                    memo:'',
                }

            },
            deleteHouse: function (index) {
                if (this.$data.newManiItem == false) {
                    return;
                }

                if (index >= this.$data.newManiItem.list.length) {
                    return;
                }
                this.$data.newManiItem.list.splice(index, 1);
            },
            editHouse: function (index) {
                if (this.$data.newManiItem == false) {
                    return;
                }

                this.$data.editHouseItem = this.$data.newManiItem.list[index];
            },
            assignItemsToHouse: function (manifest_id, house_id, house_ref) {
                var mani_string = this.$data.currentManifest.awb;

                if (this.$data.selectedItems.length == 0) {
                    this.showModal("ERROR", "송장을 선택하세요");
                    return;
                }
                var list = [];
                for (var i = 0; i < this.$data.selectedItems.length; i++) {
                    console.log("Selected " + i + " is " + this.$data.items[this.$data.selectedItems[i]].awb);
                    var item = {
                        "id": this.$data.items[this.$data.selectedItems[i]].id,
                        "mani_id": this.$data.currentManifest.id,
                        "mani_string": mani_string,
                        "house_id": house_id,
                        "house_string": house_ref,
                    };
                    list.push(item);
                }
                if (list.length == 0) {
                    console.log("No List to assign");
                    return;
                }
                var data = {
                    "table": "item_table",
                    "list": list,
                };
                var self = this;
                axios.post(process.env.APP_URL + 'api/update_items.php', data)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            console.log("Successful update");
                            var changedItems = data.items;
                            for (var i = 0; i < data.items.length; i++) {
                                for (var j = 0; j < self.$data.items.length; j++) {
                                    if (data.items[i].id == self.$data.items[j].id) {
                                        data.items[i].user_name = self.$data.items[j].user_name;
                                        data.items[i].base_price = self.$data.items[j].base_price;
                                        data.items[i].add_price = self.$data.items[j].add_price;
                                        self.$data.items[j] = data.items[i];
                                        break;
                                    }
                                }
                            }
                            self.updateHouseItem(house_id);
                        } else {
                            self.showModal("ERROR", "Failed to update " + data.message);
                        }
                        self.$data.selectedItems = [];
                    })
                    .catch(error => {

                    })
            },
            getHouseTotalData: function() {
                let self = this;
                console.log("Get all item calculation for " + this.$data.newManiItem.cargo_date);
                getHouseData(this.$data.newManiItem.cargo_date)
                .then(function(data) {
                    if(data.success == true) {
                        let item = data.item;
                        self.$data.newManiItem.count = item.totalCount;
                        self.$data.newManiItem.vw = item.vw;
                        self.$data.newManiItem.gw = item.gw;
                        self.$data.newManiItem.cw = item.cw;
                        self.calculateHouseData();

                    }
                })
                .catch(function(err) {

                })
            },
            // changeGw: function() {
            //
            //   self.calculateHouseData();
            // },
            changeManifestWeights: function() {
              let gw = document.getElementById("new-gw").value;
              let vw = document.getElementById("new-vw").value;
              let cw = document.getElementById("new-cw").value;

              if(gw == null || gw == '') {
                window.alert("Incorrect GW");
                return;
              }
              if(vw == null || vw == '') {
                window.alert("Incorrect VW");
                return;
              }
              if(cw == null || cw == '') {
                window.alert("Incorrect CW");
                return;
              }
              this.$data.newManiItem.gw = Math.round(parseFloat(gw)* 100);
              this.$data.newManiItem.vw = Math.round(parseFloat(vw)* 100);
              this.$data.newManiItem.cw = Math.round(parseFloat(cw)* 100);
              this.calculateHouseData();
            },
            calculateHouseData: function() {

                console.log("calculateHouse Data cw:" + this.$data.newManiItem.cw)
                this.$data.newManiItem.total = Number(parseFloat(this.$data.newManiItem.cw)/100*5.94 * 100);
                this.$data.newManiItem.ahc = Number(parseFloat(this.$data.newManiItem.cw)/100*0.11*100);
                if(this.$data.newManiItem.ahc < 2400) {
                  this.$data.newManiItem.ahc = 2400;
                }
                this.$data.newManiItem.avs = Number(parseFloat(this.$data.newManiItem.cw)/100*0.15*100);
                if(this.$data.newManiItem.avs < 1700) {
                  this.$data.newManiItem.avs = 1700;
                }
                this.$data.newManiItem.fsc = Number(parseFloat(this.$data.newManiItem.cw)/100*0.67*100);
                this.$data.newManiItem.moc = Number(parseFloat(this.$data.newManiItem.cw)/100*0.10*100);
            },
            updateHouseItem: function (id) {
                var self = this;
                axios.get(process.env.APP_URL + 'api/update_house.php?house_id=' + id)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            for (var i = 0; i < self.$data.manifests.length; i++) {
                                if (self.$data.manifests[i].id == data.item.manifest_id) {
                                    for (var j = 0; j < self.$data.manifests[i].list.length; j++) {
                                        if (self.$data.manifests[i].list[j].id == data.item.id) {
                                            self.$data.manifests[i].list[j] = data.item;
                                            return;
                                        }
                                    }
                                }
                            }
                        } else {
                            self.showModal("ERROR", "HOUSE 업데이트에 실패하였습니다. " + data.message);
                        }
                    })
                    .catch(error => {

                    })
            },
            onHouseConsigneeSelected: function () {
                if (this.$data.editHouseItem == false) {
                    return;
                }

                var id = this.$data.editHouseItem.consignee_id;

                var forwarder = false;
                if (id > 0) {
                    for (var i = 0; i < this.$data.forwarders.length; i++) {
                        if (this.$data.forwarders[i].id == id) {
                            forwarder = this.$data.forwarders[i];
                            break;
                        }
                    }

                }
                if (forwarder != false) {
                    this.$data.editHouseItem.consignee_title = forwarder.title;
                    this.$data.editHouseItem.consignee_post_code = forwarder.post_code;
                    this.$data.editHouseItem.consignee_address_1 = forwarder.address_1;
                    this.$data.editHouseItem.consignee_address_2 = forwarder.address_2;
                    this.$data.editHouseItem.consignee_address_3 = forwarder.address_3;
                }
            },
            onHouseShipperSelectd: function () {
                if (this.$data.editHouseItem == false) {
                    return;
                }

                var id = this.$data.editHouseItem.shipper_id;

                var shipper = false;
                if (id > 0) {
                    for (var i = 0; i < this.$data.customers.length; i++) {
                        if (this.$data.customers[i].id == id) {
                            shipper = this.$data.customers[i];
                            break;
                        }
                    }

                }
                if (shipper != false) {
                    this.$data.editHouseItem.shipper_title = shipper.title;
                    this.$data.editHouseItem.shipper_post_code = shipper.post_code;
                    this.$data.editHouseItem.shipper_address_1 = shipper.address_1;
                    this.$data.editHouseItem.shipper_address_2 = shipper.address_2;
                    this.$data.editHouseItem.shipper_address_3 = shipper.address_3;
                }
            },
            closeHouseItemForm: function () {
                this.$data.editHouseItem = false;
            },
            submitHouseItemForm: function () {
                if (this.$data.editHouseItem == false) {
                    return;
                }
                if (this.$data.editHouseItem.manifest_id == 0) {
                    this.showModal("ERROR", "Something went wrong with manifest id");
                    return;
                }
                if (this.$data.editHouseItem.ref.length == 0) {
                    this.showModal("ERROR", "HOUSE 번호를 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.description.length == 0) {
                    this.showModal("ERROR", "HOUSE Description 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.shipper_title.length == 0) {
                    this.showModal("ERROR", "Shipper명을 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.shipper_post_code.length == 0) {
                    this.showModal("ERROR", "Shipper 우편번호를 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.shipper_address_1.length == 0) {
                    this.showModal("ERROR", "Shipper 주소1을 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.shipper_address_2.length == 0) {
                    this.showModal("ERROR", "Shipper 주소2를 입력해주세요");
                    return;
                }

                if (this.$data.editHouseItem.consignee_title.length == 0) {
                    this.showModal("ERROR", "Consignee 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.consignee_post_code.length == 0) {
                    this.showModal("ERROR", "Consignee 우편번호를 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.consignee_address_1.length == 0) {
                    this.showModal("ERROR", "Consignee 주소1을 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.consignee_address_2.length == 0) {
                    this.showModal("ERROR", "Consignee 주소2를 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.consignee_address_3.length == 0) {
                    this.showModal("ERROR", "Consignee 주소3을 입력해주세요");
                    return;
                }
                if (this.$data.editHouseItem.nop.length == 0) {
                    this.$data.editHouseItem.nop = 0;
                }
                if (this.$data.editHouseItem.weight.length == 0) {
                    this.$data.editHouseItem.weight = 0;
                }
                var data = {
                    'manifest_id': this.$data.editHouseItem.manifest_id,
                    'ref': this.$data.editHouseItem.ref,
                    'description': this.$data.editHouseItem.description,
                    'shipper_id': this.$data.editHouseItem.shipper_id,
                    'shipper_title': this.$data.editHouseItem.shipper_title,
                    'shipper_post_code': this.$data.editHouseItem.shipper_post_code,
                    'shipper_address_1': this.$data.editHouseItem.shipper_address_1,
                    'shipper_address_2': this.$data.editHouseItem.shipper_address_2,
                    'shipper_address_3': this.$data.editHouseItem.shipper_address_3,
                    'consignee_id': this.$data.editHouseItem.consignee_id,
                    'consignee_title': this.$data.editHouseItem.consignee_title,
                    'consignee_address_1': this.$data.editHouseItem.consignee_address_1,
                    'consignee_address_2': this.$data.editHouseItem.consignee_address_2,
                    'consignee_address_3': this.$data.editHouseItem.consignee_address_3,
                    'consignee_post_code': this.$data.editHouseItem.consignee_post_code,
                    'nop': this.$data.editHouseItem.nop,
                    'weight': this.$data.editHouseItem.weight,
                };
                var self = this;
                if (this.$data.editHouseItem.id > 0) {
                    var url = process.env.APP_URL + 'api/update.php';
                    data['id'] = this.$data.editHouseItem.id;
                    var postData = {
                        'table': 'house_table',
                        'data': data,
                    };
                    axios.post(url, postData)
                        .then(response => {
                            var data = response.data;
                            if (data.success == true) {
                                for (var i = 0; i < self.$data.manifests.length; i++) {
                                    if (self.$data.manifests[i].id == data.item.manifest_id) {
                                        for (var j = 0; j < self.$data.manifests[i].list.length; j++) {
                                            if (self.$data.manifests[i].list[j].id == data.item.id) {
                                                self.$data.manifests[i].list[j] = data.item;
                                                self.$data.editHouseItem = false;
                                                return;
                                            }
                                        }

                                    }
                                }
                            } else {
                                self.showModal("ERROR", "House 업데이트 실패하였습니다. " + data.message);
                            }
                        })
                        .catch(error => {
                        })
                } else {
                    var url = process.env.APP_URL + 'api/create.php';
                    var postData = {
                        'table': 'house_table',
                        'data': data,
                    };
                    axios.post(url, postData)
                        .then(response => {
                            var data = response.data;
                            if (data.success == true) {
                                for (var i = 0; i < self.$data.manifests.length; i++) {
                                    if (self.$data.manifests[i].id == data.item.manifest_id) {
                                        self.$data.manifests[i].list.push(data.item);
                                        this.$data.editHouseItem = false;
                                        break;
                                    }
                                }
                            } else {
                                self.showModal("ERROR", "House 생성에 실패하였습니다. " + data.message);
                            }
                        })
                        .catch(error => {

                        })
                }
            },
            closeCurrentManifest: function () {
                console.log("closeCurrentManifest");
                this.$data.currentManifest = false;
            },
            onSearchPressed: function () {
                this.$data.items = [];
                var self = this;
                var url = process.env.APP_URL + 'api/get_items_admin.php?user_id=' + this.$data.user.id;
                if(this.$data.filter.receiver.length > 0) {
                    url += '&receiver=' + this.$data.filter.receiver;
                }
                if(this.$data.filter.sender.length > 0) {
                    url += '&sender=' + this.$data.filter.sender;
                }
                if (this.$data.filter.awb.length > 0) {
                    url += '&awb=' + this.$data.filter.awb;
                }

                if (this.$data.filter.date_from.length == 0 || this.$data.filter.date_to.length == 0) {
                    this.showModal("ERROR", "검색하고자 하는 기간을 입력해주세여");
                    return;
                }
                if (this.$data.filter.customer_id > 0) {
                    url += '&customer_id=' + this.$data.filter.customer_id;
                }
                url += '&date_from=' + this.$data.filter.date_from;
                url += '&date_to=' + this.$data.filter.date_to;


                console.log("URL: " + url);
                self.$data.items = [];
                this.pageState = this.$data.filter.state;
                axios.get(url)
                    .then(response => {
                        console.log("Get Pending");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.items = data.items;
                            for (var i = 0; self.$data.items.length; i++) {
                                self.$data.items[i].list = JSON.parse(self.$data.items[i].list);
                            }
                            self.addSelectField();
                        } else {
                            self.showModal("", data.message);
                        }
                    })
                    .catch(error => {

                    });
            },
            onGetPressed: function () {
                if (this.$data.pageState < 4) {
                    this.getFilteredList();

                } else {
                    this.$data.items = false;
                    this.getManifestList();
                }
            },
            changeStage: function (state) {
                this.$data.filter.state = state;
                this.$data.pageState = state;
                if (state < 4) {

                    this.getFilteredList();
                } else if (state == 4) {
                    this.$data.items = false;
                    this.getManifestList();
                }
            },
            getItemColor: function(item) {
                if(item.list == '' || item.list.length == 0) {
                    return 0;
                }
                let count = 0;
                for(let i = 0 ; i < item.list.length ; i++) {
                    count += item.list[i].amount;
                }
                if(count == 0) {
                    return 0;
                }

                if(item.volume_weight == 0 || item.measured_weight == 0) {
                    return 1;
                }
                return 2;
            },
            getDescriptionList: function (list) {
                let text = "";
                if (list.length > 0) {

                    text += list[0].origin_country + " " + list[0].product;

                    if (list.length > 1) {
                        let count = 0;
                        for (let i = 1; i < list.length; i++) {
                            if (list[i].amount > 0) {
                                count++;
                            }
                        }
                        if (count > 0)
                            text += " 외 " + count + "건";
                    }
                }
                return text;
            },
            getFilteredList: function () {
                var self = this;
                var url = process.env.APP_URL + 'api/get_items_admin.php?user_id=' + this.$data.user.id;
                url += '&state=' + this.$data.filter.state;
                if (this.$data.filter.state < 1) {
                    url += '&date_from=' + this.$data.filter.date_from;
                    url += '&date_to=' + this.$data.filter.date_to;
                }
                if (this.$data.filter.customer_id > 0) {
                    url += '&customer_id=' + this.$data.filter.customer_id;
                }
                console.log("URL: " + url);
                self.$data.items = [];
                this.pageState = this.$data.filter.state;
                axios.get(url)
                    .then(response => {
                        console.log("Get Pending");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                          for(let i = 0 ; i < data.items.length ; i++) {
                            if(data.items[i].list !== null && data.items[i].list.length > 0 && data.items[i].list.startsWith('"\"\"') && data.items[i].list.endsWith('\"\""')) {
                              data.items[i].list = data.items[i].list.slice(5, -5);
                            }
                            if(data.items[i].list !== null && data.items[i].list.length > 0 && data.items[i].list.startsWith('"\"') && data.items[i].list.endsWith('\""')) {
                              data.items[i].list = data.items[i].list.slice(3, -3);
                            }
                            if(data.items[i].list !== null && data.items[i].list.length > 0 && data.items[i].list.startsWith('"') && data.items[i].list.endsWith('"')) {
                              data.items[i].list = data.items[i].list.slice(1, -1);
                            }
                          }
                            self.$data.items = data.items;

                            for (var i = 0; i < self.$data.items.length; i++) {
                                self.$data.items[i].list = JSON.parse(self.$data.items[i].list);
                            }
                            self.addSelectField();
                        } else {

                        }
                    })
                    .catch(error => {

                    });
            },
            onManiReceiverSelected: function () {
                var id = this.$data.newManiItem.receiver_id;
                var forwarder = {
                    id: 0,
                    title: '',
                    post_code: '',
                    address_1: '',
                    address_2: '',
                    address_3: '',
                    telephone: '',
                    fax: '',
                };
                for (var i = 0; i < this.$data.forwarders.length; i++) {
                    if (this.$data.forwarders[i].id == id) {
                        forwarder = this.$data.forwarders[i];
                    }
                }

                this.$data.newManiItem.receiver = forwarder.title;
                this.$data.newManiItem.receiver_id = forwarder.id;
                this.$data.newManiItem.post_code = forwarder.post_code;
                this.$data.newManiItem.address_1 = forwarder.address_1;
                this.$data.newManiItem.address_2 = forwarder.address_2;
                this.$data.newManiItem.address_3 = forwarder.address_3;
                this.$data.newManiItem.telephone = forwarder.telephone;
                this.$data.newManiItem.fax = forwarder.fax;
            },
            createManifest: function () {
                this.$data.newManiItem = {
                    id: 0,
                    awb: "",
                    cargo_date: '',
                    airline: 'KOREAN AIRLINE',
                    flight: '',
                    flight2: '',
                    origin: 'LONDON HEATHROW',
                    destination: 'INCHEON AIRPORT',
                    receiver: '',
                    receiver_id: 0,
                    address_1: "",
                    address_2: "",
                    address_3: "",
                    post_code: "",
                    telephone: "",
                    departure_time: "",
                    arrival_time: "",
                    fax: "",
                    cargo_type: "UNKNOWN CARGO",
                    vehicle_reg: "YA24SWX",
                    list: [
                        {
                            ref: 1,
                            house_ref: "UTZ",
                            npo: 0,
                            description: '',
                            dest: '',
                            weight: 0,
                            agent: '',
                            shipper_id: 0,
                            shipper_title: '',
                            shipper_address_1: '',
                            shipper_address_2: '',
                            shipper_post_code: '',
                            consignee_id: 0,
                            consignee_title: '',
                            consignee_address_1: '',
                            consignee_address_2: '',
                            consignee_post_code: '',
                        }
                    ],
                  airlineTitle:'KOREAN AIR',
                  airlineAddress1: 'SEOSOMUN-RO 117',
                  airlineAddress2: 'JUNG-GU, SEOUL, KOREA',
                  deliveryPointAddress1: 'KOREAN AIRLINES',
                  deliveryPointAddress2: 'C/O SWISSPORT',
                  deliveryPointAddress3: 'BEDFONT ROAD, LONDON HEATHROW AIRPORT',
                  deliveryPointAddress4: 'STAINES, MIDDLESEX, TW19 7NL',
                  count:0,
                  gw:0,
                  vw:0,
                  cw:0,
                  rate:594,
                  ahc:0,
                  fsc:0,
                  moc:0,
                  avs:0,
                  total:0,
                  accountingInfo:'KCX',
                  signedDate:millisToDate(new Date().getTime()),
                  signedBy:'JOHN HWANG',
                  goodsDescription:'CONSOLIDATION CARGO\n' +
                    'NON RESTRICTED\n' +
                    'CARGO AS ADDRESSED',
                };
            },
            closeNewManiItemForm: function () {
                this.$data.newManiItem = false;
            },
            onAWBEntered: function () {
                if (this.$data.newManiItem == false) {
                    return;
                }

                if (this.$data.newManiItem.awb.length != 12) {
                    this.showModal("ERROR", "AWB xxx-xxxxxxxx형식으로 입력해주세요 1 ");
                    return;
                }

                if (!this.$data.newManiItem.awb.includes("-")) {
                    this.showModal("ERROR", "AWB xxx-xxxxxxxx형식으로 입력해주세요 2");
                    return;
                }
                var words = this.$data.newManiItem.awb.split("-");
                if (words.length != 2) {
                    this.showModal("ERROR", "AWB xxx-xxxxxxxx형식으로 입력해주세요 3");
                    return;
                }
                if (words[0].length != 3) {
                    this.showModal("ERROR", "AWB xxx-xxxxxxxx형식으로 입력해주세요 4");
                    return;
                }
                if (words[1].length != 8) {
                    this.showModal("ERROR", "AWB xxx-xxxxxxxx형식으로 입력해주세요 5");
                    return;
                }
                if (words[0] == '180') {
                    this.$data.newManiItem.flight = 'KE908';
                    this.$data.newManiItem.origin = 'LHR';
                    this.$data.newManiItem.destination = 'ICN';
                } else if (words[0] == '988') {
                    this.$data.newManiItem.flight = 'OZ522';
                    this.$data.newManiItem.origin = 'LHR';
                    this.$data.newManiItem.destination = 'ICN';
                }
            },
            submitNewMainfest: function () {
                if (this.$data.newManiItem == false) {
                    return;
                }
                if (this.$data.newManiItem.awb.length != 12) {
                    this.showModal("ERROR", "AWB xxx-xxxxxxxx형식으로 입력해주세요");
                    return;
                }
                if (this.$data.newManiItem.cargo_date.length == 0) {
                    this.showModal("ERROR", "출발 날짜를 선택해주세요");
                    return;
                }
                console.log("Departure time " + this.$data.newManiItem.departure_time);
                console.log("Arrival time " + this.$data.newManiItem.arrival_time);

                for(let i = 0 ; i < this.$data.newManiItem.list.length ; i++) {
                  if(this.$data.newManiItem.list[i].memo !== undefined && this.$data.newManiItem.list[i].memo.includes("\n")) {
                    this.$data.newManiItem.list[i].memo = this.$data.newManiItem.list[i].memo.replace(/\n/g, "\\n");
                  }
                }

                console.log("House List");
                console.log(JSON.stringify(this.$data.newManiItem.list));
                // return;
                let data = {
                    "awb": this.$data.newManiItem.awb,
                    "cargo_date": this.$data.newManiItem.cargo_date,
                    "airline": this.$data.newManiItem.airline,
                    "flight": this.$data.newManiItem.flight,
                    "flight2": this.$data.newManiItem.flight2,
                    "origin": this.$data.newManiItem.origin,
                    "destination": this.$data.newManiItem.destination,
                    "receiver": this.$data.newManiItem.receiver,
                    "receiver_id": this.$data.newManiItem.receiver_id,
                    "address_1": this.$data.newManiItem.address_1,
                    "address_2": this.$data.newManiItem.address_2,
                    "address_3": this.$data.newManiItem.address_3,
                    "post_code": this.$data.newManiItem.post_code,
                    "telephone": this.$data.newManiItem.telephone,
                    "fax": this.$data.newManiItem.fax,
                    "list": JSON.stringify(this.$data.newManiItem.list),
                    "departure_time": this.$data.newManiItem.departure_time,
                    "arrival_time": this.$data.newManiItem.arrival_time,
                    count:this.$data.newManiItem.count,
                    gw:this.$data.newManiItem.gw,
                    vw:this.$data.newManiItem.vw,
                    cw:this.$data.newManiItem.cw,
                    rate:this.$data.newManiItem.rate,
                    ahc:this.$data.newManiItem.ahc,
                    fsc:this.$data.newManiItem.fsc,
                    moc:this.$data.newManiItem.moc,
                    avs:this.$data.newManiItem.avs,
                    total:this.$data.newManiItem.total,
                    signedDate:this.$data.newManiItem.signedDate,
                    signedBy:this.$data.newManiItem.signedBy,
                    cargo_type:this.$data.newManiItem.cargo_type,
                    vehicle_reg:this.$data.newManiItem.vehicle_reg,
                    accountingInfo:this.$data.newManiItem.accountingInfo,
                  airlineTitle: this.$data.newManiItem.airlineTitle,
                  airlineAddress1: this.$data.newManiItem.airlineAddress1,
                  airlineAddress2: this.$data.newManiItem.airlineAddress2,
                  deliveryPointAddress1: this.$data.newManiItem.deliveryPointAddress1,
                  deliveryPointAddress2: this.$data.newManiItem.deliveryPointAddress2,
                  deliveryPointAddress3: this.$data.newManiItem.deliveryPointAddress3,
                  deliveryPointAddress4: this.$data.newManiItem.deliveryPointAddress4,
                  goodsDescription: this.$data.newManiItem.goodsDescription,
                };
                let self = this;
                console.log("ID = " + this.$data.newManiItem.id);
                if (this.$data.newManiItem.id > 0) {
                    data["id"] = this.$data.newManiItem.id;
                    var postData = {
                        "table": "manifest_table",
                        "data": data,
                    };
                    console.log("update manifest");
                    console.log(data);
                    axios.post(process.env.APP_URL + 'api/update.php', postData)
                        .then(response => {
                            console.log(response);
                            var data = response.data;
                            if (data.success == true) {
                                console.log("Successful update");

                                console.log("Set editItem to false");
                                for (var i = 0; i < self.$data.manifests.length; i++) {
                                    if (data.item.id == self.$data.manifests[i].id) {
                                        data.item.list = JSON.parse(data.item.list);
                                        self.$data.manifests.splice(i, 1, data.item);
                                        //self.$data.manifests[i].id = data.item;
                                        break;
                                    }
                                }
                                self.$data.newManiItem = false;

                            } else {
                                self.showModal("ERROR", "Failed to update " + data.message);
                            }
                        })
                        .catch(error => {
                            console.log(error);
                            if(error.response != undefined) {
                              console.log(error.response);
                            }
                        })
                } else {
                    axios.post(process.env.APP_URL + 'api/create_manifest.php', data)
                        .then(response => {
                            console.log(response);
                            var data = response.data;
                            if (data.success == true) {
                                console.log("Successful update");

                                console.log("Set editItem to false");
                                self.$data.newManiItem = false;
                                data.item.list = JSON.parse(data.item.list);
                                self.$data.manifests.push(data.item);
                            } else {
                                self.showModal("ERROR", "Failed to create " + data.message);
                            }
                        })
                        .catch(error => {

                        })
                }
            },
            deleteItem: function (index) {
                var message = "송장 " + this.$data.items[index].awb + "를 지우시겠습니까?";

                var self = this;
                this.$modal.show('dialog', {
                    title: "DELETE ITEM",
                    text: message,
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '삭제',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.deleteItemConfirm(index);
                            }
                        },
                    ]
                })
                return;
            },
            deleteItemConfirm: function (index) {
                var data = {
                    id: this.$data.items[index].id,
                    deleted: 1,
                    deleted_time: getTimeStamp(),
                    deleted_by: 'UTACO'
                };
                var postData = {
                    "table": "item_table",
                    "data": data,
                };
                var self = this;
                axios.post(process.env.APP_URL + 'api/update.php', postData)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            self.$data.items.splice(index, 1);
                        } else {
                            self.showModal("ERROR", data.message);
                        }
                    })
                    .catch(error => {
                        self.showModal("ERROR", error);
                    })
            },
            editItemForm: function (index) {
                console.log("editItemForm");

                this.$data.editItem = JSON.parse(JSON.stringify(this.$data.items[index]));
                if(this.$data.editItem.measured_weight > 0) {
                  this.$data.editItem.measured_weight = parseFloat(this.$data.editItem.measured_weight)/100;
                }
                console.log(this.$data.editItem);
            },
            closeEditItemForm: function () {
                this.$data.editItem = false;
            },
            printItems: function (type=0) {
                console.log(this.$data.selectedItems);
                if(this.$data.selectedItems.length == 0) {
                    this.showModal("", "출력할 송장을 선택해주세요");
                    return;
                }
                let ids = [];
                // for (let selectedItem in this.$data.selectedItems) {
                //     console.log("selected index " + selectedItem)
                //     ids.push(this.$data.items[selectedItem].id);
                // }
                for (let i = 0; i < this.$data.selectedItems.length; i++) {
                    ids.push(this.$data.items[this.$data.selectedItems[i]].id);
                }

                this.$data.paperType = type;
                var str = ids.join(",");

                console.log(str);
                var self = this;

                var url = process.env.APP_URL + 'api/';
                if(type == 0) {
                    url += 'print_labels.php?ids=' + str;
                } else if(type == 1) {
                    url += 'print_label_horizontal.php?ids=' + str;
                } else if(type == 2) {
                    url += 'print_labels_a4.php?ids=' + str;
                } else if(type == 3) {
                    url += 'print_labels_a4_2x2.php?ids=' + str;
                }
                console.log("URL = " + url);
                this.$data.labelHtml = url;
                this.$data.showLabelPrint = true;
//                 axios.get(url)
//                     .then(function(response) {
//                         console.log("label print data");
//                         console.log(response);
//                         if(response.data != undefined) {
//
//                             console.log("set response");
//                             self.$data.labelHtml = response.data;
//                             self.$data.showLabelPrint = true;
// }
//                     })
//                     .catch(function(error) {
//
//                     });
                //window.open(url);

            },
            closeLabelView: function() {
                this.$data.labelHtml = false;
                this.$data.showLabelPrint = false;
                this.$data.selectedItems = [];
            },
            printSelectedLabels: function () {
                let index = -1;
                for (let i = 0; i < this.$data.selectedItems.length; i++) {
                    index = this.$data.selectedItems[i];
                    break;
                }

                if (index == -1) {
                    return;
                }
                if(this.$data.items[index].code_list.length > 0) {
                    this.printLabel(index, JSON.parse(this.$data.items[index].code_list), this.$data.items[index].ct, true);
                    return;
                }
                console.log("printItem");
                let zipCode = this.$data.items[index].post_code;
                if(zipCode.includes(" ")) {
                    zipCode = zipCode.replace(" ", "");
                }
                let address = this.$data.items[index].address_1;
                if (this.$data.items[index].address_2.length > 0) {
                    address += ' ' + this.$data.items[index].address_2;
                }
                console.log("printItem zipCode = " + zipCode);
                console.log("printItem address = " + address);

                let self = this;
                this.$data.isLoading = true;
                getDepotCode(zipCode, address)
                    .then(function (data) {
                        self.$data.isLoading = false;
                        console.log("getDepotCode Response");
                        console.log(data);
                        if (data.cmmMsgHeader.successYN == 'Y') {
                            self.printLabel(index, data.delivAreaCdList, self.$data.items[index].ct, true);
                        }

                    })
                    .catch(function (err) {
                        self.$data.isLoading = false;
                        console.log(err);
                    })
            },
            printItem: function (index) {
                console.log("printItem");
                if(this.$data.items[index].code_list.length > 0) {
                    this.printLabel(index, JSON.parse(this.$data.items[index].code_list), this.$data.items[index].ct);
                    return;
                }
                let zipCode = this.$data.items[index].post_code;
                if(zipCode.includes(" ")) {
                    zipCode = zipCode.replace(" ", "");
                }
                let address = this.$data.items[index].address_1;
                if (this.$data.items[index].address_2.length > 0) {
                    address += ' ' + this.$data.items[index].address_2;
                }
                console.log("printItem zipCode = " + zipCode);
                console.log("printItem address = " + address);

                let self = this;
                this.$data.isLoading = true;
                getDepotCode(zipCode, address)
                    .then(function (data) {
                        self.$data.isLoading = false;
                        console.log("getDepotCode Response");
                        console.log(data);
                        if (data.cmmMsgHeader.successYN == 'Y') {
                            self.printLabel(index, data.delivAreaCdList, self.$data.items[index].ct);
                        }

                    })
                    .catch(function (err) {
                        self.$data.isLoading = false;
                        console.log(err);
                    })
            },
            printLabel: function (index, cdList, count, moveToNext = false) {
                let self = this;
                self.$data.isLoading = true;


                let extra = "수량 " + this.$data.items[index].ct + "-" + count;
                //extra += "   무게: " + (this.$data.items[index].measured_weight / 100).toFixed(2) + 'Kg';
                playSound();
                // playWarningSound();
                requestPrintLabel(cdList, this.$data.items[index], extra)
                    .then(function (response) {
                        self.$data.isLoading = false;
                        if(response.data.includes("Failed to connect to printer")) {
                          self.showModal("ERROR", "프린터가 연결 되지 않습니다. 프린터를 다시 껏다가 켜주세요");
                          playWrongSound();
                          return;
                        }
                        console.log("PRINT LABEL DONE");

                        let item = {
                          "id": self.$data.items[index].id,
                          "printedCount": parseInt(self.$data.items[index].printedCount) +1,
                          "printedTime": new Date().getTime(),
                        }
                        let postData = {
                          'table': 'item_table',
                          'data': item,
                        }
                        self.incrementPrintCount(postData);
                        let newCount = count -1;
                        if(newCount > 0) {
                            self.printLabel(index, cdList, newCount, moveToNext);
                            return;
                        }
                        if (moveToNext) {
                            for (let i = 0; i < self.$data.selectedItems.length; i++) {

                                if (self.$data.selectedItems[i] == index) {
                                    self.$data.selectedItems.splice(i, 1);
                                    self.printSelectedLabels();
                                }
                            }
                        }
                    })
                    .catch(function (err) {
                        console.log("requestPrintLabel failed " + err);
                        console.log(err);

                        playWrongSound();
                        if(!err.status) {
                          window.alert("프린터가 연결 안되어 있는것으로 보입니다.");
                        }
                        if(err.response != undefined ) {
                          if(err.response.status != undefined) {
                            console.log(err.response.status)
                          }
                        }

                        self.$data.isLoading = false;
                    })
            },
            incrementPrintCount: function(postData) {
              let self = this;
              axios.post(process.env.APP_URL + 'api/update.php', postData)
                .then(response => {
                  // self.$data.isLoading = false;
                  console.log(response);
                  var data = response.data;
                  if (data.success == true) {
                    console.log("Successful update");
                    for (let i = 0; i < self.$data.items.length; i++) {
                      if (self.$data.items[i].id == data.item.id) {
                        self.$data.items[i].printedCount = data.item.printedCount;
                        self.$data.items[i].printedTime = data.item.printedTime;
                        return;
                      }
                    }
                  } else {

                  }
                })
              .catch(function(err) {

              })
            },
            getTodayData: function () {
                var myDate = new Date();
                var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
                var date = ('0' + myDate.getDate()).slice(-2);
                var year = myDate.getFullYear();
                var formattedDate = year + '-' + month + '-' + date;
                return formattedDate;
            },
            onAddGood: function () {
                let newGood = {
                    product: "",
                    brand: "",
                    site_url: "",
                    amount: 0,
                    hs_code: -1,
                    origin_country: "",
                    value: 0,
                    liquid: 0,
                };
                this.$data.editItem.list.push(newGood);
            },
            verifySendDate: function () {
                if (this.$data.editItem.dispatch_date.length == 0 || this.$data.editItem.dispatch_date == '0000-00-00') {
                    this.showModal("ERROR", "보내는 날짜를 선택해주세요");
                    return;
                }

                if (this.$data.editItem.dispatch_date < this.getTodayData()) {
                    this.showModal("ERROR", "불가능한 날짜입니다.");
                    this.$data.editItem.dispatch_date = '0000-00-00';
                    return;
                }
            },
            validateGoods: function () {
                if (this.$data.editItem == false) {
                    return false;
                }
                if (this.$data.editItem.list.length == 0) {
                    this.showModal("ERROR", "물품을 추가해주세요");
                    return false;
                }

                console.log(this.$data.editItem.list);

                for (let i = this.$data.editItem.list.length - 1; i >= 0; i--) {

                    if (this.$data.editItem.list[i].amount == 0 && i >= 5) {
                        this.$data.editItem.list.splice(i, 1);

                    }
                }
                if (this.$data.editItem.list.length == 0) {
                    this.showModal("ERROR", "물품을 추가해주세요");
                    return false;
                }
                this.countTotalValue();
                return true;
            },
            countTotalValue: function () {
                if (this.$data.editItem == false) {
                    return;
                }
                this.$data.editItem.value = 0;
                if (this.$data.editItem.list.length == 0) {
                    return;
                }
                for (let i = 0; i < this.$data.editItem.list.length; i++) {
                    this.$data.editItem.value += parseInt(this.$data.editItem.list[i].value) * parseInt(this.$data.editItem.list[i].amount);
                }

            },
            verifyItemForm: function () {
                if (this.$data.editItem.sender.length < 1) {
                    this.showModal("ERROR", "보내는 사람을 입력해주세요");
                    return false;
                }
                if (this.$data.editItem.code.length != 4) {
                    this.showModal("ERROR", "보내는 사람을 입력해주세요");
                    return false;
                }
                if (this.$data.editItem.sender_post_code.length < 5) {
                    this.showModal("ERROR", "Post code Required");
                    return false;
                }
                if (this.$data.editItem.sender_address_1.length < 1) {
                    this.showModal("ERROR", "Address Required");
                    return false;
                }
                if (this.$data.editItem.sender_address_2.length < 1) {
                    this.showModal("ERROR", "Address Detail Required");
                    return false;
                }
                if (this.$data.editItem.sender_contact.length < 1) {
                    this.showModal("ERROR", "Sender Contact Required");
                    return false;
                }
                if (this.$data.editItem.receiver.length < 2) {
                    this.showModal("ERROR", "Name Required");
                    return false;
                }
                if (this.$data.editItem.receiver_contact.length < 10) {
                    this.showModal("ERROR", "Phone number Required");
                    return false;
                }
                if (this.$data.editItem.post_code.length < 5) {
                    this.showModal("ERROR", "Post code Required");
                    return false;
                }
                if (this.$data.editItem.address_1.length < 1) {
                    this.showModal("ERROR", "Address Required");
                    return false;
                }
                // if(this.$data.editItem.address_2.length < 1) {
                //   this.showModal("ERROR", "Address Detail Required");
                //   return false;
                // }
                if (this.$data.editItem.value.length < 0) {
                    this.showModal("ERROR", "Value Required");
                    return false;
                }
                if (this.$data.editItem.forwarder_id < 0) {
                    this.showModal("ERROR", "Select Forwarder");
                    return false;
                }
                if (this.$data.editItem.dispatch_date.length == 0 || this.$data.editItem.dispatch_date == '0000-00-00') {
                    this.showModal("ERROR", "Select Date to Send");
                    return false;
                }

                return this.validateGoods();
            },
            senderSelected: function () {
                if (this.$data.editItem == false) {
                    return;
                }
                this.$data.editItem.sender = '';
                this.$data.editItem.code = '';
                this.$data.editItem.sender_address_1 = '';
                this.$data.editItem.sender_address_2 = '';
                this.$data.editItem.sender_post_code = '';
                this.$data.editItem.sender_contact = '';
                if (this.$data.editItem.customer_id > 0) {

                    for (var i = 0; i < this.$data.customers.length; i++) {
                        if (this.$data.customers[i].id == this.$data.editItem.customer_id) {
                            this.$data.editItem.sender = this.$data.customers[i].title;
                            this.$data.editItem.code = this.$data.customers[i].code;
                            this.$data.editItem.sender_address_1 = this.$data.customers[i].address_1;
                            this.$data.editItem.sender_address_2 = this.$data.customers[i].address_2;
                            this.$data.editItem.sender_post_code = this.$data.customers[i].post_code;
                            this.$data.editItem.sender_contact = this.$data.customers[i].contact_mobile;
                            break;
                        }
                    }


                }
            },
            openNewItemForm: function () {
                let today = new Date();
                this.$data.editItem = {
                    id: 0,
                    customer_id: 0,
                    code: '',
                    list: [
                        {
                            product: '',
                            brand: '',
                            site_url: '',
                            amount: 0,
                            value: 0,
                            origin_country: '',
                            liquid: 0,
                        },
                        {
                            product: '',
                            brand: '',
                            site_url: '',
                            amount: 0,
                            value: 0,
                            origin_country: '',
                            liquid: 0,
                        },
                        {
                            product: '',
                            brand: '',
                            site_url: '',
                            amount: 0,
                            value: 0,
                            origin_country: '',
                            liquid: 0,
                        },
                        {
                            product: '',
                            brand: '',
                            site_url: '',
                            amount: 0,
                            value: 0,
                            origin_country: '',
                            liquid: 0,
                        },
                        {
                            product: '',
                            brand: '',
                            site_url: '',
                            amount: 0,
                            value: 0,
                            origin_country: '',
                            liquid: 0,
                        },
                    ],
                    sender: '',
                    sender_post_code: '',
                    sender_address_1: '',
                    sender_address_2: '',
                    sender_contact: '',
                    receiver: '',
                    receiver_contact: "",
                    custom_number: "",
                    who_pays_tax: 0,
                    who_pays_inspection: 0,
                    email: "",
                    national_id: "",
                    post_code: "",
                    address_1: "",
                    address_2: "",
                    code_list:'',
                    ct: 1,
                    deliery_company_id: 0,
                    value: 0,
                    forwarder_id: 4,
                    forwarder_string: "CWAY",
                    dispatch_date: millisToDate(today.getTime(), '-'),
                    "volume_x": 0,
                    "volume_y": 0,
                    "volume_z": 0,
                    "volume_weight": 0,
                    "measured_weight": 0,
                    "weight": 0,
                    "price": 0,
                    "base_price": 0,
                    "add_price": 0,
                    "custom_type": "목",
                    "trade_type": "A",
                    "seller_type": 2,

                }
            },
            calculateTotalValue: function() {
                console.log("calculateValue");
                if(this.$data.editItem.list.length == 0) {
                    this.$data.editItem.value = 0;
                    return;
                }

                let totalValue = 0;
                for(let i = 0 ; i < this.$data.editItem.list.length ; i++) {
                    if(this.$data.editItem.list[i].amount== "" || this.$data.editItem.list[i].value == '') {

                        continue;
                    }
                    console.log(i + " item " + this.$data.editItem.list[i].amount + " " + this.$data.editItem.list[i].value);
                    totalValue += (Number(this.$data.editItem.list[i].amount)*parseFloat(this.$data.editItem.list[i].value));
                }
                this.$data.editItem.value = totalValue;
                console.log("total Value = " + this.$data.editItem.value);
            },
            submitEditItem: function () {
                console.log("submitNewItem");
                if (this.verifyItemForm() == false) {
                    return;
                }
                let item = {
                    "customer_id": this.$data.editItem.customer_id,
                    "sender": this.$data.editItem.sender,
                    "code": this.$data.editItem.code,
                    "sender_address_1": this.$data.editItem.sender_address_1,
                    "sender_address_2": this.$data.editItem.sender_address_2,
                    "sender_post_code": this.$data.editItem.sender_post_code,
                    "sender_contact": this.$data.editItem.sender_contact,
                    "dispatch_date": this.$data.editItem.dispatch_date,
                    "receiver": this.$data.editItem.receiver,
                    "receiver_contact": this.$data.editItem.receiver_contact,
                    "email": this.$data.editItem.email,
                    "post_code": this.$data.editItem.post_code,
                    "address_1": this.$data.editItem.address_1,
                    "address_2": this.$data.editItem.address_2,
                    "ct": this.$data.editItem.ct,
                    "value": this.$data.editItem.value,
                    "volume_x": this.$data.editItem.volume_x,
                    "volume_y": this.$data.editItem.volume_y,
                    "volume_z": this.$data.editItem.volume_z,
                    "volume_weight": this.$data.editItem.volume_weight,
                    "measured_weight": this.$data.editItem.measured_weight*100,
                    "weight": this.$data.editItem.weight,
                    "price": this.$data.editItem.price,
                    "base_price": this.$data.editItem.base_price,
                    "add_price": this.$data.editItem.add_price,
                    "forwarder_id": this.$data.editItem.forwarder_id,
                    "forwarder_string": this.$data.editItem.forwarder_string,
                    "custom_number": this.$data.editItem.custom_number,
                    "who_pays_tax": this.$data.editItem.who_pays_tax,
                    "who_pays_inspection": this.$data.editItem.who_pays_inspection,
                    "national_id": this.$data.editItem.national_id,
                    "list": JSON.stringify(this.$data.editItem.list),
                    "custom_type": this.$data.editItem.custom_type,
                    "trade_type": this.$data.editItem.trade_type,
                    "seller_type": this.$data.editItem.seller_type,
                    "note": this.$data.editItem.note,
                    "code_list":"",
                };

                console.log(item);
                //return;
                let zipCode = item.post_code;
                if(zipCode.includes(" ")) {
                    zipCode = zipCode.replace(" ", "");
                }
                let address = item.address_1;
                if (item.address_2.length > 0) {
                    address += ' ' + item.address_2;
                }
                console.log("printItem zipCode = " + zipCode);
                console.log("printItem address = " + address);
                let self = this;
                this.$data.isLoading = true;
                getDepotCode(zipCode, address)
                    .then(function(dcdata) {
                        self.$data.isLoading = false;
                        if (dcdata.cmmMsgHeader.successYN == 'Y') {

                            item.code_list = JSON.stringify(dcdata.delivAreaCdList);

                        }
                        self.postSubmitItem(item);
                    })
                    .catch(function(err) {
                        self.$data.isLoading = false;
                        console.log("ERR to update " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                        self.postSubmitItem(item);
                    })

            },
            postSubmitItem: function(item) {
                var self = this;
                self.$data.isLoading = true;
                if (this.$data.editItem.id > 0) {
                    item["id"] = this.$data.editItem.id;
                    var postData = {
                        "table": "item_table",
                        "data": item,
                    };
                    axios.post(process.env.APP_URL + 'api/update.php', postData)
                        .then(response => {
                            self.$data.isLoading = false;
                            console.log(response);
                            var data = response.data;
                            if (data.success == true) {
                                console.log("Successful update");
                                for (let i = 0; i < self.$data.items.length; i++) {
                                    if (self.$data.items[i].id == data.item.id) {
                                        data.item.selected = self.$data.items[i].selected;
                                        data.item.user_name = self.$data.items[i].user_name;
                                        // data.item.base_price = self.$data.items[i].base_price;
                                        // data.item.add_price = self.$data.items[i].add_price;
                                        data.item.list = JSON.parse(data.item.list);

                                        self.$data.items.splice(i, 1, data.item);
                                        //self.$data.items[i] = data.item;
                                        break;
                                    }
                                }
                                console.log("Set editItem to false");
                                self.$data.editItem = false;
                            } else {
                                self.showModal("ERROR", "Failed to update " + data.message);
                            }
                        })
                        .catch(error => {
                            self.$data.isLoading = false;
                            self.showModal("ERROR", "죄송합니다. 생성 실패했습니다. " + error);
                        })
                } else {
                    axios.post(process.env.APP_URL + 'api/add_new_item.php', item)
                        .then(response => {
                            self.$data.isLoading = false;
                            console.log(response);
                            var data = response.data;
                            if (data.success == true) {
                                data.item.list = JSON.parse(data.item.list);
                                self.$data.items.push(data.item);
                                self.$data.editItem = false;
                            } else {
                                self.showModal("ERROR", "Failed to create new AWB " + data.message);
                            }
                        })
                        .catch(error => {
                            self.$data.isLoading = false;
                            self.showModal("ERROR", "죄송합니다. 생성 실패했습니다. " + error);
                        })
                }
            },
            getTodayDate: function () {
                let now = new Date();
                let year = now.getFullYear();
                let month = now.getMonth() + 1;
                let day = now.getDate();

                if (month.toString().length == 1) {
                    month = '0' + month;
                }
                if (day.toString().length == 1) {
                    day = '0' + day;
                }

                let dateTime = year + '-' + month + '-' + day;
                return dateTime;
            },
            getCurrentTime: function () {
                let now = new Date();
                let year = now.getFullYear();
                let month = now.getMonth() + 1;
                let day = now.getDate();
                let hour = now.getHours();
                let minute = now.getMinutes();
                let second = now.getSeconds();
                if (month.toString().length == 1) {
                    month = '0' + month;
                }
                if (day.toString().length == 1) {
                    day = '0' + day;
                }
                if (hour.toString().length == 1) {
                    hour = '0' + hour;
                }
                if (minute.toString().length == 1) {
                    minute = '0' + minute;
                }
                if (second.toString().length == 1) {
                    second = '0' + second;
                }
                let dateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
                return dateTime;
            },
            prepareToMoveOut: function () {
                //Check if there is today's manifest감


                if(this.$data.items.length == 0) {
                    console.log("No items to move out");
                    return;
                }



                let today = this.$data.items[0].dispatch_date;//this.getTodayDate();



                let url = process.env.APP_URL + 'api/get_manifest.php?date_from=' + today + '&date_to=' + today;
                let self = this;
                this.$data.manifests = [];
                console.log("getManifestList " + url);
                axios.get(url)
                    .then(response => {
                        console.log("Get Manifests");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            if (data.items.length > 0) {

                                if(data.items[0].flight == undefined || data.items[0].flight.length == 0 || data.items[0].flight === '') {
                                    self.showModal("", today + "의 Manifest에 비행편명이 없습니다.");
                                    return;
                                }

                                let departureTime = data.items[0].departure_time;
                                let arrivalTime = data.items[0].arrival_time;

                                if(departureTime === "" || departureTime === '0000-00-00 00:00:00' || departureTime.endsWith("00:00:00")) {
                                    self.showModal("", today + "의 Manifest에 출발시간이 없습니다.");
                                    return;
                                }
                                if(arrivalTime === "" || arrivalTime === '0000-00-00 00:00:00' || arrivalTime.endsWith("00:00:00")) {
                                    self.showModal("", today + "의 Manifest에 도착시간이 없습니다.");
                                    return;
                                }
                                self.moveOut(today, departureTime, arrivalTime);
                            } else {
                                self.showModal("", today + "의 Manifest가 없습니다.");
                                return;
                            }


                        } else {
                            self.showModal("", today + "의 Manifest를 찾을 수 없습니다");
                            return;
                        }
                    })
                    .catch(error => {
                        console.log("error "+ error);
                        if(error.response != undefined) {
                            console.log(error.response);
                        }
                        self.showModal("", "에러 발생");
                    });
            },
            moveOut: function(dispatch_day, departureTime, arrivalTime) {
                let list = [];
                for (let i = 0; i < this.$data.selectedItems.length; i++) {

                    if(dispatch_day === this.$data.items[this.$data.selectedItems[i]].dispatch_date) {
                        let item = {
                            "id": this.$data.items[this.$data.selectedItems[i]].id,
                            "state": 4
                        };
                        item.departure_time = departureTime;
                        item.arrival_time = arrivalTime;
                        list.push(item);
                    }
                }

                if(list.length == 0) {
                    this.showModal("ERROR", "최종 마감할수 있는 아이템이 없습니다.");
                    return;
                }
                let data = {
                    "table": "item_table",
                    "list": list,
                };
                var self = this;
                axios.post(process.env.APP_URL + 'api/update_items.php', data)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            console.log("Successful update");
                            var changedItems = data.items;
                            for (var i = 0; i < data.items.length; i++) {
                                for (var j = 0; j < self.$data.items.length; j++) {
                                    if (data.items[i].id == self.$data.items[j].id) {
                                        if (data.items[i].state != self.$data.pageState) {
                                            self.$data.items.splice(j, 1);
                                        }
                                        break;
                                    }
                                }
                            }
                        } else {
                            self.showModal("ERROR", "Failed to update " + data.message);
                        }
                        self.$data.selectedItems = [];
                    })
                    .catch(error => {

                    })
            },
            chageState: function (newState, departureTime = "", arrivalTime = "") {
                console.log("changeState");
                console.log(this.$data.selectedItems);


                //return;
                let list = [];
                for (let i = 0; i < this.$data.selectedItems.length; i++) {
                    console.log("Selected " + i + " is " + this.$data.items[this.$data.selectedItems[i]].awb);
                    if (newState >= 1 && this.$data.items[this.$data.selectedItems[i]].price > 0) {
                        let item = {
                            "id": this.$data.items[this.$data.selectedItems[i]].id,
                            "state": newState
                        };
                        if (newState == 1) {
                            item.in_time = this.getCurrentTime();
                            item.prepare_out_time = "";
                            item.out_time = "";
                            item.departure_time = "";
                            item.arrival_time = "";
                        } else if (newState == 2) {
                            item.prepare_out_time = this.getCurrentTime();
                            item.out_time = "";
                            item.departure_time = "";
                            item.arrival_time = "";
                        } else if (newState == 3) {
                            item.out_time = this.getCurrentTime();
                            item.departure_time = "";
                            item.arrival_time = "";
                        } else if (newState == 4) {
                            if (departureTime != "" && departureTime.length > 0) {
                                item.departure_time = departureTime;

                            } else {
                                item.departure_time = "";
                            }
                            if (arrivalTime != "" && arrivalTime.length > 0) {
                                item.arrival_time = arrivalTime;
                            } else {
                                item.arrival_time = "";
                            }
                        }
                        list.push(item);
                    }
                }

                if (list.length == 0) {
                    this.showModal("ERROR", newState + "차 마감할수 있는 아이템이 없습니다.");
                    return;
                }

                let data = {
                    "table": "item_table",
                    "list": list,
                };
                var self = this;
                axios.post(process.env.APP_URL + 'api/update_items.php', data)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            console.log("Successful update");
                            var changedItems = data.items;
                            for (var i = 0; i < data.items.length; i++) {
                                for (var j = 0; j < self.$data.items.length; j++) {
                                    if (data.items[i].id == self.$data.items[j].id) {
                                        if (data.items[i].state != self.$data.pageState) {
                                            self.$data.items.splice(j, 1);
                                        }
                                        break;
                                    }
                                }
                            }
                        } else {
                            self.showModal("ERROR", "Failed to update " + data.message);
                        }
                        self.$data.selectedItems = [];
                    })
                    .catch(error => {

                    })
            },
            onCountrySelected: function () {
                console.log("onCountrySelected");
                if (this.$data.newItem == false) {
                    return;
                }
                console.log("Selected " + this.$data.editItem.origin_country);
                for (var i = 0; i < this.$data.countries.length; i++) {
                    if (this.$data.countries[i].title == this.$data.editItem.origin_country) {
                        if (this.$data.countries[i].val == 1) {
                            this.$data.editItem.fta = 'FTA';
                        } else {
                            break;
                        }
                        return;
                    }
                }
                this.$data.newItem.fta = '';
            },
            roundDown: function (number, decimals) {
                decimals = decimals || 0;
                return (Math.floor(number * Math.pow(10, decimals)) / Math.pow(10, decimals));
            },
            onVolumeEntered: function () {
                this.$data.editItem.volume_weight = this.$data.editItem.volume_x * this.$data.editItem.volume_y * this.$data.editItem.volume_z / 6000;
                this.$data.editItem.volume_weight = parseFloat(this.$data.editItem.volume_weight).toFixed(2)*100;
                console.log("Scaled Weight " + this.$data.editItem.measured_weight);
                console.log("Volume Weight " + this.$data.editItem.volume_weight);
                this.$data.editItem.weight = this.$data.editItem.volume_weight > this.$data.editItem.measured_weight*100 ? this.$data.editItem.volume_weight : this.$data.editItem.measured_weight*100;
                console.log("Weight " + this.$data.editItem.weight);
                if (this.$data.editItem.weight <= 100) {
                    this.$data.editItem.price = this.$data.editItem.base_price;
                } else {
                    var extra = this.$data.editItem.weight - 100;
                    var extraUnit = parseInt(extra / 50);
                    if (extra % 50 >= 10) {
                        extraUnit += 1;
                    }
                    console.log("extra " + extraUnit);
                    this.$data.editItem.price = Number(this.$data.editItem.base_price) + Number(extraUnit) * Number(this.$data.editItem.add_price);
                }

            },
            findAddress: function () {
                this.$data.showAddressFinder = true;
                var self = this;
                new daum.Postcode({
                    oncomplete: function (data) {
                        // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

                        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
                        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                        var addr = ''; // 주소 변수
                        var extraAddr = ''; // 참고항목 변수

                        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
                        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                            addr = data.roadAddress;
                        } else { // 사용자가 지번 주소를 선택했을 경우(J)
                            addr = data.jibunAddress;
                        }

                        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
                        if (data.userSelectedType === 'R') {
                            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                            if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
                                extraAddr += data.bname;
                            }
                            // 건물명이 있고, 공동주택일 경우 추가한다.
                            if (data.buildingName !== '') {
                                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
                            }
                            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                            if (extraAddr !== '') {
                                extraAddr = ' (' + extraAddr + ')';
                            }
                            // 조합된 참고항목을 해당 필드에 넣는다.
                            //document.getElementById("sample2_extraAddress").value = extraAddr;

                        } else {
                            //document.getElementById("sample2_extraAddress").value = '';
                        }

                        // 우편번호와 주소 정보를 해당 필드에 넣는다.
                        self.$data.editItem.post_code = data.zonecode;
                        self.$data.editItem.address_1 = addr;

                        if (extraAddr !== '') {
                            self.$data.editItem.address_1 += extraAddr;
                        }
                        self.$data.showAddressFinder = false;
                        $("#finder-container").css('display', 'none');
                        $("#postcodeFinderLayer").css('display', 'none');

                    },
                    width: '100%',
                    height: '100%',
                    maxSuggestItems: 5
                }).embed(document.getElementById('postcodeFinderLayer'));

                // iframe을 넣은 element를 보이게 한다.
                $("#finder-container").css('display', 'block');
                $("#postcodeFinderLayer").css('display', 'block');
            },
            closeAddressFinder: function () {
                this.$data.showAddressFinder = false;
                $("#finder-container").css('display', 'none');
                $("#postcodeFinderLayer").css('display', 'none');
            },
            printManifest: function () {
                if (this.$data.newManiItem == false) {
                    return;
                }
                var url = process.env.APP_URL + 'api/print_manifest.php?id=' + this.$data.newManiItem.id;
                window.open(url);
            },
            printDeliveryNote: function(id) {
                if (this.$data.newManiItem == false) {
                  return;
                }
                if(id == 0) {

                }
                var url = process.env.APP_URL + 'api/print_delivery_note.php?id=' + id;
                window.open(url);
            },
            printAwb: function(id) {
                if (this.$data.newManiItem == false) {
                  return;
                }
                if(id == 0) {

                }
                var url = process.env.APP_URL + 'api/airway_bill.php?id=' + id;
                window.open(url);
            },
            printHouseBill: function(index) {


                var url = process.env.APP_URL + 'api/house_bill.php?id=' + this.$data.newManiItem.id + "&houseIndex=" + index;
                window.open(url);
            },
            printHouse: function (index) {
                // this.printHouseBill(index);
                // return;
                if (this.$data.newManiItem == false) {
                    return;
                }
                if (this.$data.newManiItem.list.length == 0) {
                    return;
                }


                let consignee = this.$data.newManiItem.list[index].consignee_title;
                let addr1 = this.$data.newManiItem.list[index].consignee_address_1;
                let addr2 = this.$data.newManiItem.list[index].consignee_address_2;
                let addr3 = this.$data.newManiItem.list[index].consignee_post_code;

                let totalPieces = 0;
                for(let i = 0 ; i < this.$data.newManiItem.list.length ; i++) {
                  totalPieces += parseInt(this.$data.newManiItem.list[i].nop);
                }
                let mawb = this.$data.newManiItem.awb;
                let hwab = this.$data.newManiItem.list[index].house_ref;
                let hwabpcs = this.$data.newManiItem.list[index].nop;

                let count = document.getElementById("house-print-count-" + index).value;
                if(count == '') {
                  count = 1;
                }
                let airline = this.$data.newManiItem.airlineTitle;
                console.log("Count " + count);
                let self = this;
                self.$data.isLoading = true;
                printHouseLabel(consignee, addr1, addr2, addr3, totalPieces, mawb, hwab, hwabpcs, count, airline)
                .then(function(data) {
                  self.$data.isLoading = false;
                })
                .catch(function(err) {
                  self.$data.isLoading = false;
                })
                // var url = process.env.APP_URL + 'api/print_house.php?id=' + this.$data.newManiItem.id + '&house_ref=' + ref;
                // window.open(url);

            },
            getStateString: function (state) {
                return getStateString(state);
            },
            getStateTimeString: function(index) {
                return getStateTimeString(this.$data.items[index])  + '<span class="tooltiptext text-left"'+ this.getStatusTooltip(index) + '</span>';;
            },
            getStatusTooltip: function(index) {
                return getStatusString(this.$data.items[index]);
            },
            printFTASelected: function() {
              if(this.$data.selectedItems.length > 0) {


                let idList = [];
                for(let i = 0 ; i < this.$data.selectedItems.length && i < 50; i++) {
                  idList.push(this.$data.items[this.$data.selectedItems[i]].id);
                }
                let ids = idList.join(',');
                let url = "https://api.utasco.net/api/fta_views.php?ids=" + ids;
                window.open(url);
              }
            },
            getFTADocsForSelected: function() {
              if(this.$data.selectedItems.length > 0) {


                let idList = [];
                for(let i = 0 ; i < this.$data.selectedItems.length && i < 50; i++) {
                  idList.push(this.$data.items[this.$data.selectedItems[i]].id);
                }
                let ids = idList.join(',');
                downloadFTADocMulti(ids);
                this.$data.selectedItems.splice(0, idList.length);
                if(this.$data.selectedItems.length > 0) {
                  window.alert("한번에 받을 수 있는 FTA서류는 50개까지 입니다. 나머지 " + this.$data.selectedItems.length + "개 항목은 그대로 선택되어 있습니다. FTA버튼을 클릭하시면 추가로 받으실 수 있습니다");
                }
              }
            },
            getFTADoc: function (id) {

                console.log("Search " + id);
                downloadFTADoc(id);
            },
            onProductEntered: function (index) {
                if (this.$data.editItem == false) {
                    return;
                }
                if (this.$data.editItem.list.length < index) {
                    return;
                }

                if (this.$data.editItem.list[index].product.length > 0) {
                    if (this.$data.editItem.list[index].amount == 0) {
                        this.$data.editItem.list[index].amount = 1;
                    }
                } else {
                    this.$data.editItem.list[index].amount = 0;
                }
                if (this.$data.editItem.list[index].product.length > 0) {
                    // if (this.$data.editItem.list[index].product.includes('"') || this.$data.editItem.list[index].product.includes("'")) {
                    //     this.showModal("에러", "특수문자는 사용할수 없습니다");
                        this.$data.editItem.list[index].product = this.$data.editItem.list[index].product.replace(/[^0-9a-zA-Z.()\- ]/g, "");


                    // }
                }


              if (this.$data.editItem.list[index].site_url !== null && this.$data.editItem.list[index].site_url.length > 0) {
                this.$data.editItem.list[index].site_url = this.$data.editItem.list[index].site_url.replace(/[^a-zA-Z0-9.()\- ]/g, "");
              }
            },
            checkBrandSpecialKey: function (index) {
                if (this.$data.editItem == false) {
                    return;
                }
                if (this.$data.editItem.list.length < index) {
                    return;
                }
                if (this.$data.editItem.list[index].brand.length > 0) {
                    // if (this.$data.editItem.list[index].brand.includes('"') || this.$data.editItem.list[index].brand.includes("'")) {
                    this.$data.editItem.list[index].brand = this.$data.editItem.list[index].brand.replace(/[^a-zA-Z0-9.()\- ]/g, "");
                        //this.$data.newItem.list[index].brand.replace('"', "");
                        // this.showModal("에러", "특수문자는 사용할수 없습니다");


                    // }
                }
            },
            toggleEditMode: function() {
                this.$data.editMode = !this.$data.editMode;
                for(let i = 0 ; i < this.$data.items.length ; i++) {
                  if(this.$data.editMode == true) {
                    if(this.$data.items[i].measured_weight > 0) {
                      this.$data.items[i].new_measured_weight = parseFloat((this.$data.items[i].measured_weight/100).toFixed(2));
                    } else {
                      this.$data.items[i].new_measured_weight = 0;
                    }

                    if(this.$data.items[i].volume_weight > 0) {
                      this.$data.items[i].new_volume_weight = parseFloat((this.$data.items[i].volume_weight/100).toFixed(2));
                    } else {
                      this.$data.items[i].new_volume_weight = 0;
                    }
                  } else {

                  }
                }
            },
            weightChanged: function(index) {

                this.$data.items[index].measured_weight = Number(this.$data.items[index].new_measured_weight*100)
                this.$data.items[index].volume_weight = Number(this.$data.items[index].new_volume_weight*100)
                this.$data.items[index].weight = this.$data.items[index].measured_weight;
                if(this.$data.items[index].volume_weight > this.$data.items[index].measured_weight) {
                    this.$data.items[index].weight = this.$data.items[index].volume_weight;
                }
                if (this.$data.items[index].weight <= 100) {
                    this.$data.items[index].price = this.$data.items[index].base_price;
                } else {
                    let extra = this.$data.items[index].weight - 100;
                    let extraUnit = parseInt(extra / 50);
                    if (extra % 50 > 0) {
                        extraUnit += 1;
                    }
                    console.log("extra " + extraUnit);
                    this.$data.items[index].price = Number(this.$data.items[index].base_price) + Number(extraUnit) * Number(this.$data.items[index].add_price);
                }
                this.updateItem(index);
            },
            updateAllDispatchDate: function(newDate) {
                let list = [];
                for (let i = 0; i < this.$data.items.length; i++) {
                    let item = {
                        "id": this.$data.items[i].id,
                        "dispatch_date": newDate,
                    };
                    list.push(item);
                }
                if (list.length == 0) {
                    console.log("No List to assign");
                    return;
                }
                var data = {
                    "table": "item_table",
                    "list": list,
                };
                var self = this;
                this.$data.isLoading = true;
                axios.post(process.env.APP_URL + 'api/update_items.php', data)
                    .then(response => {
                        self.$data.isLoading = false;
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            console.log("Successful update");
                            var changedItems = data.items;
                            for (let i = 0; i < data.items.length; i++) {
                                for (let j = 0; j < self.$data.items.length; j++) {
                                    if(self.$data.items[j].id == data.items[i].id) {
                                        data.items[i].user_name = self.$data.items[j].user_name;
                                        data.items[i].base_price = self.$data.items[j].base_price;
                                        data.items[i].add_price = self.$data.items[j].add_price;

                                        self.$data.items.splice(j, 1, data.items[i]);
                                        self.$data.items[j].list = JSON.parse(self.$data.items[j].list);

                                        break;
                                    }
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        self.$data.isLoading = false;
                    })
            },
            updateDispatchDate: function(index) {
                if(index == 0) {
                    //Ask to change all date?
                    let self = this;
                    this.$modal.show('dialog', {
                        //title: '로그아웃',
                        text: '모든 송장 출발일 변경하시겠습니까?',
                        buttons: [
                            {
                                title: '아니요',
                                handler: () => {
                                    self.$modal.hide('dialog');
                                    self.updateItem(index);

                                }
                            },
                            {
                                title: '일괄변경',
                                handler: () => {
                                    self.$modal.hide('dialog');
                                    self.updateAllDispatchDate(self.$data.items[index].dispatch_date);
                                }
                            },

                        ]

                    });

                } else {
                    this.updateItem(index);
                }
            },
            updateItem: function(index) {
                console.log("item changed " + index);
                console.log(this.$data.items[index].dispatch_date);
                let data = {
                    id: this.$data.items[index].id,
                    dispatch_date: this.$data.items[index].dispatch_date,
                    // volume_x: this.$data.editItem.volume_x,
                    // volume_y: this.$data.editItem.volume_y,
                    // volume_z: this.$data.editItem.volume_z,
                    volume_weight: this.$data.items[index].volume_weight,
                    measured_weight: this.$data.items[index].measured_weight,
                    weight: this.$data.items[index].weight,
                    // base_price: this.$data.editItem.base_price,
                    // add_price: this.$data.editItem.add_price,
                    price: this.$data.items[index].price,
                };
                let postData = {
                    "table": "item_table",
                    "data": data,
                };
                let self = this;
                axios.post(process.env.APP_URL + 'api/update.php', postData)
                    .then(response => {
                        console.log(response);
                        var data = response.data;
                        if (data.success == true) {
                            console.log("Successful update");

                            //self.$data.editItem = false;
                        } else {
                            self.showModal("ERROR", "Failed to update " + data.message);
                        }
                    })
                    .catch(error => {
                        self.showModal("ERROR", "Failed to update " + error);
                    })

            },
            sortByAWB: function() {
                this.$data.sortList.awb = !this.$data.sortList.awb;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.awb > b.awb) {

                        return self.$data.sortList.awb?1:-1;
                    }
                    return self.$data.sortList.awb?-1:1;
                })
            },
            sortBySender: function() {
                this.$data.sortList.sender = !this.$data.sortList.sender;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.sender > b.sender) {
                        return self.$data.sortList.sender?1:-1;
                    }
                    return self.$data.sortList.sender?-1:1;
                })
            },
            sortByCode: function() {
                this.$data.sortList.code = !this.$data.sortList.code;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.code > b.code) {
                        return self.$data.sortList.code?1:-1;
                    }
                    return self.$data.sortList.code?-1:1;
                })
            },
            sortByDispatchDate: function() {
                this.$data.sortList.dispatch_date = !this.$data.sortList.dispatch_date;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.dispatch_date > b.dispatch_date) {
                        return self.$data.sortList.dispatch_date?1:-1;
                    }
                    return self.$data.sortList.dispatch_date?-1:1;
                })
            },
            sortByReceiver: function() {
                this.$data.sortList.receiver = !this.$data.sortList.receiver;
                if(this.$data.items.length  == 0) {
                    return;
                }
                let self = this;
                this.$data.items.sort(function(a, b){
                    if(a.receiver > b.receiver) {
                        return self.$data.sortList.receiver?1:-1;
                    }
                    return self.$data.sortList.receiver?-1:1;
                })
            },
            sortByValue: function() {
              this.$data.sortList.value = !this.$data.sortList.value;
              if(this.$data.items.length  == 0) {
                return;
              }
              let self = this;
              this.$data.items.sort(function(a, b){
                if(parseFloat(a.value) > parseFloat(b.value)) {
                  return self.$data.sortList.value?1:-1;
                }
                return self.$data.sortList.value?-1:1;
              })
            }

        }

    }
</script>
<style lang="css" scoped>
  .table td {
    padding:.25rem;
  }
  .form-control {
    height: calc(1.0em + 1.0rem + 2px);
  }
  .form-group {
    margin-bottom:0.5rem;
  }
  .card-header h4 {
    margin-bottom:0;
  }
  .new-item-form {
    background:#D4D4D4;
    z-index:3;
  }
  .card {
    box-shadow: 5px 5px 5px grey;
    margin-bottom:20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Panel.vue